/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import { DEFAULT_GRID_OPTIONS } from "@material-ui/x-grid";
import { withStyles } from "@material-ui/core/styles";
// import { hasValue, LogDebug, updateObject } from "../shared/utility";
import {
  doLog,
  getAppOptions,
  getYYYYMMDD,
  getMMDDYYYY,
  getMMDDYYYYTime,
  hasValue,
  updateObject,
} from "../shared/utility";

import classes from "./CrimeSubmission.css";

import * as actions from "../store/actions/index";
import Attachments from "./Attachments";
// import blankshield from "blankshield";
import Button from "@material-ui/core/Button";
import Card from "../components/UI/Card/Card";
import Checkbox from "@material-ui/core/Checkbox";
import Form from "../components/UI/Form/Form";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import Persons from "./Persons";
import Properties from "./Properties";
import SectionHeading from "../components/UI/SectionHeading/SectionHeading";
import Spinner from "../components/UI/Spinner/Spinner";
import Vehicles from "./Vehicles";

// import Box from "@mui/material/Box";
// import ClearIcon from "@mui/icons-material/Clear";
// import IconButton from "@mui/material/IconButton";
// import SearchIcon from "@mui/icons-material/Search";
// import TextField from "@mui/material/TextField";

const mappedSelectPropFields = [
  "incidentType",
  "incidentState",
  "olnState",
  "userState",
  "towState",
  "eyeColor",
  "hairColor",
  "personInvolvement",
  "ethnicity",
  //
  "incidentStateSearch",
];

const mappedTextPropFields = [
  "firstName",
  "middleName",
  "lastName",
  "email",
  "homePhone",
  "cellPhone",
  "workPhone",
  "race",
  "sex",
  "dob",
  "oln",
  "ssn",
  "height",
  "weight",
  //
  "id",
  "incidentNumber",
  "incidentFromDate",
  "incidentToDate",
  "incidentDesc",
  //
  "incidentBusinessName",
  "incidentStreetNumber",
  "incidentStreetName",
  "incidentApt",
  "incidentCity",
  "incidentState",
  "incidentZip",
  //
  "userBusinessName",
  "userStreetNumber",
  "userStreetName",
  "userApt",
  "userCity",
  //"userState",
  "userZip",
  //
  "towCompanyName",
  "towStreetNumber",
  "towStreetName",
  "towApt",
  "towCity",
  "towZip",
  //
  "status",
  "incidentTypeSearch",
  //
  "incidentBusinessNameSearch",
  "incidentStreetNumberSearch",
  "incidentStreetNameSearch",
  "incidentAptSearch",
  "incidentCitySearch",
  "incidentStateSearch",
  "incidentZipSearch",
  //
  "timsAddressNumber",
  //
  "paramStartDate",
  "paramEndDate",
];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  textField: {
    width: 250,
  },
  dense: {
    marginTop: 19,
  },
  spacing: 1,
});

const quote = '"';
const singleQuote = "'";
const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40
const { rowHeight, headerHeight } = DEFAULT_GRID_OPTIONS;

class CrimeSubmission extends Form {
  state = {
    searching: false,
    submitting: false,
    reportRunning: false,
    // retrieveDetailsRunning: false,
    initialDownloadsComplete: false,
    incidentDetailsLoaded: false,
    fbrMode: null,
    editMode: true,
    useSameAddress: false,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    initialFieldErrMsg: "Please wait while we get everything set up",
    sectionName: "CrimeSubmission",
    runIncidentSearch: false,
    runTIMSSearch: false,
    fieldUpdate: false,
    //
    gridSearchText: "",
    gridDefaultRows: [],
    gridRows: [],
    //
    selectedIncidentTypeData: null,
    typeCodeChanged: false,
    requiredFieldsComplete: false,
    olnValidationRequired: false,
    towFieldsRequired: false,
    //
    incidentID: null,
    personnelID: null,
    personnelName: null,
    //
    attachmentsRunning: false,
    currentFile: null,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    personInvolvement: {
      inputType: "select",
      labelValue: null,
      value: "C",
      label: "Involvement Type",
      listName: "personInvolvementList",
      codegroup: "163",
      validation: { required: false },
    },
    firstName: {
      inputType: "text",
      value: "",
      label: "First Name",
      maxSize: 20,
      validation: { required: false },
    },
    middleName: {
      inputType: "text",
      value: "",
      label: "Middle",
      maxSize: 20,
    },
    lastName: {
      inputType: "text",
      value: "",
      label: "Last Name",
      maxSize: 30,
      validation: { required: false },
    },
    email: {
      inputType: "email",
      value: "",
      label: "Email",
      maxSize: 50,
      validation: { required: false },
    },
    homePhone: { inputType: "phone", value: "", label: "Home Phone" },
    cellPhone: { inputType: "phone", value: "", label: "Cell Phone" },
    workPhone: { inputType: "phone", value: "", label: "Work Phone" },
    race: {
      inputType: "select",
      valueField: "raceValue",
      value: null,
      label: "Race",
      listName: "raceList",
      codegroup: "8",
      validation: { required: false },
    },
    sex: {
      inputType: "select",
      valueField: "sexValue",
      value: null,
      label: "Gender",
      listName: "sexList",
      codegroup: "9",
      validation: { required: false },
    },
    ethnicity: {
      inputType: "select",
      valueField: "ethnicityValue",
      value: null,
      label: "Ethnicity",
      listName: "ethnicityList",
      codegroup: "10",
      validation: { required: false },
    },
    dob: {
      inputType: "date",
      value: null,
      label: "Date of Birth",
      disableFuture: true,
      validation: { required: false },
    },
    height: {
      inputType: "height",
      value: "",
      label: "Height",
    },
    weight: {
      inputType: "number",
      value: "",
      label: "Weight",
    },
    eyeColor: {
      inputType: "select",
      valueField: "eyeColorValue",
      value: null,
      label: "Eye Color",
      listName: "eyeColorList",
      codegroup: "13",
    },
    hairColor: {
      inputType: "select",
      valueField: "hairColorValue",
      value: null,
      label: "Hair Color",
      listName: "hairColorList",
      codegroup: "14",
    },
    ssn: {
      inputType: "ssn",
      value: "",
      label: "SSN",
    },
    oln: {
      inputType: "text",
      value: "",
      label: "Driver License #",
      maxSize: 25,
      upperOnly: true,
    },
    olnState: {
      inputType: "select",
      valueField: "olnStateValue",
      value: null,
      label: "License State",
      listName: "stateList",
      codegroup: "162",
    },
    userBusinessName: {
      inputType: "text",
      value: "",
      maxSize: 30,
      label: "Business Name (If appropriate)",
    },
    userStreetNumber: {
      inputType: "text",
      value: "",
      label: "Street #",
      maxSize: 10,
    },
    userStreetName: {
      inputType: "text",
      value: "",
      label: "Street Name",
      maxSize: 50,
    },
    userApt: {
      inputType: "text",
      value: "",
      label: "Unit",
      maxSize: 32,
    },
    userCity: { inputType: "text", value: "", label: "City", maxSize: 32 },
    userState: {
      inputType: "select",
      valueField: "userStateValue",
      value: null,
      label: "State",
      listName: "stateList",
      codegroup: "162",
    },
    userZip: { inputType: "text", value: "", label: "Zip", maxSize: 10 },
    //
    // personInvolvement: {
    //   inputType: "select",
    //   labelValue: null,
    //   value: null,
    //   label: "Involvement Type",
    //   listName: "personInvolvementList",
    //   codegroup: "163",
    //   validation: { required: true },
    // },
    //
    propertyType: {
      inputType: "select",
      labelValue: null,
      value: null,
      label: "Property Type",
      listName: "propertyTypeList",
      codegroup: "29",
      validation: { required: true },
    },
    propertyColor: {
      inputType: "select",
      labelValue: null,
      value: null,
      label: "Color",
      listName: "propertyColorList",
      codegroup: "161",
    },
    //
    vehicleInvolvement: {
      inputType: "select",
      labelValue: null,
      value: null,
      label: "Involvement Type",
      listName: "vehicleInvolvementList",
      codegroup: "164",
      validation: { required: true },
    },
    vehicleStateCode: {
      inputType: "select",
      labelValue: null,
      value: "MI",
      label: "Licensing State",
      listName: "stateList",
      codegroup: "162",
      validation: { required: true },
    },
    vehicleBodyStyle: {
      inputType: "select",
      labelValue: null,
      value: null,
      label: "Body Style",
      listName: "vehicleBodyStyleList",
      codegroup: "17",
    },
    vehicleMake: {
      inputType: "select",
      labelValue: null,
      value: null,
      label: "Make",
      listName: "vehicleMakeList",
      codegroup: "160",
      validation: { required: true },
    },
    vehicleColor1: {
      inputType: "select",
      labelValue: null,
      value: null,
      label: "Color",
      listName: "vehicleColorList",
      codegroup: "161",
    },
    //
    incidentTypeSearch: {
      inputType: "datagridsearch",
      gridFieldName: "incidentType",
      value: null,
      searchText: null,
      label: "Select an Incident Type",
      maxSize: 30,
    },
    //
    incidentType: {
      inputType: "datagrid",
      value: null,
      label: null,
      validation: { required: true },
      listName: "incidentTypeList",
      useSearch: true,
      searchText: "",
      gridColumns: [],
      gridDefaultRows: [],
      gridRows: [],
      selectedRows: [-1],
      rowCount: 4,
      hideFooter: true,
      onGridRowClick: (fieldName) => (param, event) => {
        this.handleIncidentTypeChange(fieldName, param, event);
      },
      onGridCheckBoxClick: (fieldName) => (newSelectionModel) => {
        this.handleIncidentTypeCheckbox(fieldName, newSelectionModel);
      },
    },
    id: {
      inputType: "text",
      value: "-1",
      label: "ID",
      maxSize: 30,
    },
    incidentNumber: {
      inputType: "text",
      value: "",
      label: "Incident Number",
      maxSize: 30,
    },
    incidentFromDate: {
      inputType: "datetime",
      value: moment().format("MM/DD/YYYY hh:mm A"),
      label: "Earliest Date/Time",
      disableFuture: true,
    },
    incidentToDate: {
      inputType: "datetime",
      value: moment().format("MM/DD/YYYY hh:mm A"),
      label: "Latest Date/Time",
      disableFuture: true,
    },
    incidentDesc: {
      inputType: "text",
      value: "",
      label:
        "Enter a Description of the Incident. (Provide as much detail as you can)",
      multiline: true,
      rows: 8,
      validation: { required: true },
    },
    //
    incidentBusinessName: {
      inputType: "text",
      value: "",
      label:
        "Business Name or Location Name if applicable (Park, intersection, etc.)",
      maxSize: 30,
    },
    incidentStreetNumber: {
      inputType: "text",
      value: "",
      label: "Street #",
      maxSize: 10,
    },
    incidentStreetName: {
      inputType: "text",
      value: "",
      label: "Street Name",
      maxSize: 50,
    },
    incidentApt: {
      inputType: "text",
      value: "",
      label: "Unit",
      maxSize: 32,
    },
    incidentCity: { inputType: "text", value: "", label: "City", maxSize: 32 },
    incidentState: {
      inputType: "select",
      valueField: "incidentStateValue",
      value: null,
      label: "State",
      listName: "stateList",
      codegroup: "162",
    },
    incidentZip: { inputType: "text", value: "", label: "Zip", maxSize: 10 },
    //
    towCompanyName: {
      inputType: "text",
      value: "",
      label: "Tow Company Name",
      maxSize: 100,
    },
    towStreetNumber: {
      inputType: "text",
      value: "",
      label: "Street #",
      maxSize: 10,
    },
    towStreetName: {
      inputType: "text",
      value: "",
      label: "Street Name",
      maxSize: 50,
    },
    towApt: {
      inputType: "text",
      value: "",
      label: "Unit",
      maxSize: 32,
    },
    towCity: { inputType: "text", value: "", label: "City", maxSize: 32 },
    towState: {
      inputType: "select",
      valueField: "towStateValue",
      value: null,
      label: "State",
      listName: "stateList",
      codegroup: "162",
    },
    towZip: { inputType: "text", value: "", label: "Zip", maxSize: 10 },
    status: { inputType: "text", value: "", label: "Status", maxSize: 10 },
    //
    incidentBusinessNameSearch: {
      inputType: "text",
      value: "",
      label:
        "Business Name or Location Name if applicable (Park, intersection, etc.)",
      maxSize: 30,
      upperOnly: true,
    },
    incidentStreetNumberSearch: {
      inputType: "text",
      value: "",
      label: "Street #",
      maxSize: 10,
      upperOnly: true,
    },
    incidentStreetNameSearch: {
      inputType: "text",
      value: "",
      label: "Street Name",
      maxSize: 50,
      upperOnly: true,
    },
    incidentAptSearch: {
      inputType: "text",
      value: "",
      label: "Unit",
      maxSize: 32,
      upperOnly: true,
    },
    incidentCitySearch: {
      inputType: "text",
      value: "",
      label: "City",
      maxSize: 32,
      upperOnly: true,
    },
    incidentStateSearch: {
      inputType: "select",
      valueField: "incidentStateValue",
      value: null,
      label: "State",
      listName: "stateList",
      codegroup: "162",
    },
    incidentZipSearch: {
      inputType: "text",
      value: "",
      label: "Zip",
      maxSize: 10,
      upperOnly: true,
    },
    //
    priorIncidentSearch: {
      inputType: "checkbox",
      value: "N",
      default: "N",
      label: "Search Your Prior Field Based Incidents: (Optional)",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    //
    paramStartDate: {
      inputType: "datepicker",
      value: null,
      label: "From Date",
      disableFuture: true,
    },
    paramEndDate: {
      inputType: "datepicker",
      value: moment().format("MM/DD/YYYY"),
      label: "To Date",
      disableFuture: true,
    },
    //
    timsSearch: {
      inputType: "checkbox",
      value: "N",
      default: "N",
      label: "Search in TIMS: (Optional)",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    timsAddressNumber: {
      inputType: "text",
      value: "-1",
      label: "TIMSAddressNumber",
      validation: { required: false },
    },
    //
    validCodeOptions:
      "raceList|8," +
      "sexList|9," +
      "ethnicityList|10," +
      "eyeColorList|13," +
      "hairColorList|14," +
      "stateList|162," +
      "personInvolvementList|163," +
      "propertyTypeList|29," +
      "vehicleInvolvementList|164," +
      "vehicleBodyStyleList|17," +
      "vehicleMakeList|160," +
      "vehicleColorList|161",
  };

  checkIncidentComplete() {
    return this.props.reportError === null && this.props.reportResult !== null;
  }

  checkListFiles() {
    if (doLog())
      console.log("[CrimeSubmission] checkListFiles props:", this.props);
    let ori = "";
    let id = "-1";
    const appOptions = getAppOptions("update");
    //console.log("[CrimeSubmission] appOptions:", appOptions);
    if (hasValue(appOptions)) {
      const incidentUpdateValue = appOptions["update"];
      if (doLog())
        console.log(
          "[CrimeSubmission] checkListFiles incidentUpdateValue:",
          incidentUpdateValue
        );
      if (hasValue(incidentUpdateValue)) {
        const valueArray = incidentUpdateValue.split("|");
        if (hasValue(valueArray) && valueArray.length > 1) {
          ori = valueArray[0];
          id = valueArray[1];
        }
      }
    }

    if (this.props.configuration != null) {
      if (
        this.props.configuration !== null &&
        this.props.configuration.ciddbConnectionName !== null
      ) {
        if (
          hasValue(this.props.modulePermissions) &&
          this.props.modulePermissions.allowTIMS &&
          hasValue(this.props.userId) &&
          this.state.personnelID === null
        ) {
          if (!hasValue(this.props.result) && !this.state.searching) {
            const transactionType = "GetPersonnelIDFromUserName";
            const data = {
              userId: this.props.userId,
            };
            const request = {
              transactionType,
              data,
            };
            this.setState({ searching: true });
            this.props.onRunTransaction(request, this.props.token);
          }
        } else if (
          this.props.incidentTypeList === null &&
          !this.props.incidentTypeLoading
        ) {
          this.props.onFetchIncidentTypeList(
            this.props.configuration.ori,
            this.props.token
          );
        } else if (
          this.props.customTextList === null &&
          !this.props.customTextLoading &&
          !this.props.incidentTypeLoading
        ) {
          this.props.onFetchCustomTextList(
            this.props.agencyCode,
            this.props.token
          );
        } else if (
          this.props.raceList === null &&
          !this.props.multipleListLoading &&
          !this.props.incidentTypeLoading &&
          !this.props.customTextLoading
        ) {
          this.props.onFetchMultipleValidCodeLists(
            this.props.configuration.ori,
            this.props.token,
            this.state.validCodeOptions
          );
        } else if (
          this.props.requiredFieldList === null &&
          !this.props.requiredFieldLoading &&
          hasValue(this.props.selectedIncidentTypeData)
        ) {
          this.props.onFetchRequiredFieldList(
            this.props.configuration.ori,
            this.props.token,
            this.props.selectedIncidentTypeData.INCIDENTTYPE
          );
        } else if (
          this.props.incidentDetails === null &&
          !this.props.incidentDetailsLoading &&
          !this.props.multipleListLoading &&
          !this.props.incidentTypeLoading &&
          !this.props.customTextLoading &&
          hasValue(ori) &&
          hasValue(id)
        ) {
          this.props.onFetchIncidentDetails(this.props.token, ori, id);
        } else if (
          this.state.typeCodeChanged &&
          hasValue(this.props.requiredFieldList)
        ) {
          this.setFieldRequiredSettings("Incident");
          if (doLog())
            console.log(
              "[CrimeSubmission] checkListFiles this.props.selectedIncidentTypeData:",
              this.props.selectedIncidentTypeData
            );
          if (hasValue(this.props.selectedIncidentTypeData)) {
            if (doLog())
              console.log(
                "[CrimeSubmission] checkListFile stypeCodeChanged requiretowinfo:",
                this.props.selectedIncidentTypeData.REQUIRETOWINFO
              );
            if (this.props.selectedIncidentTypeData.REQUIRETOWINFO === "Y") {
              this.setFieldRequiredSettings("Tow");
            } else {
              if (this.isfbrPermitted) this.setFieldRequiredSettingsOff("User");
              else this.setFieldRequiredSettings("User");
            }
            this.setState({
              typeCodeChanged: false,
              requiredFieldsComplete: true,
            });
          }
        } else if (
          // Load previous contents of the fields
          this.props.incidentDetails !== null &&
          !this.state.incidentDetailsLoaded
        ) {
          this.handleIncidentDetailsLoad(
            id,
            this.props.incidentDetails[0]["data"]
          );
        } else if (
          !this.props.incidentDetailsLoading &&
          !this.props.multipleListLoading &&
          !this.props.incidentTypeLoading &&
          !this.props.customTextLoading
        ) {
          this.setDefaultStateCode();

          if (!this.state.initialDownloadsComplete) {
            this.setState({ initialDownloadsComplete: true });
          }

          let typeCode = this.state.incidentType.value;
          let typeData = this.state.selectedIncidentTypeData;
          //this.loadIncidentTypeList(this.props.selectedIncidentTypeData.INCIDENTTYPE, this.props.selectedIncidentTypeData);
          this.loadIncidentTypeList(typeCode, typeData);

          // let array = [];
          // if (hasValue(this.props.incidentTypeList)) {
          //   const selectedTypeCode = this.state.incidentType.value;
          //   const selectedIncidentTypeData = {
          //     value: selectedTypeCode,
          //     data: this.state.selectedIncidentTypeData,
          //   };
          //   if (doLog())
          //     console.log(
          //       "[CrimeSubmission] checkListFiles selectedTypeCode:" +
          //         selectedTypeCode +
          //         " selectedIncidentTypeData:",
          //       selectedIncidentTypeData
          //     );
          //   if (hasValue(selectedTypeCode)) {
          //     array.push(selectedIncidentTypeData);
          //   }

          //   for (let i = 0; i < this.props.incidentTypeDataList.length; i++) {
          //     const row = this.props.incidentTypeDataList[i];
          //     let permitted = false;
          //     if (row !== null) {
          //       if (
          //         !hasValue(selectedTypeCode) ||
          //         selectedTypeCode !== row.data.INCIDENTTYPE
          //       ) {
          //         permitted = true;
          //         if (doLog())
          //           console.log("[CrimeSubmission] checkListFiles row[" + i + "]:", row);
          //         const permission = row.data.PERMISSIONNAME;
          //         if (hasValue(permission) && typeof permission === "string") {
          //           if (doLog())
          //             console.log(
          //               "[CrimeSubmission] checkListFiles incident type of " +
          //                 row.data.INCIDENTTYPE +
          //                 " permission needed:",
          //               permission
          //             );
          //           permitted = false;
          //           const appOptions = getAppOptions(permission);
          //           // console.log("[CrimeSubmission] appOptions:", appOptions);
          //           const permissionValue = appOptions[permission];
          //           if (doLog())
          //             console.log(
          //               "[CrimeSubmission] checkListFiles permissionValue:",
          //               permissionValue
          //             );
          //           if (
          //             hasValue(permissionValue) &&
          //             permissionValue.toUpperCase().startsWith("T")
          //           ) {
          //             permitted = true;
          //           }
          //         }
          //       } else permitted = false;
          //     }
          //     if (permitted) {
          //       array.push(row);
          //     }
          //   }
          // }

          // if (
          //   array !== null &&
          //   array.length > 0 &&
          //   this.state.incidentType.gridDefaultRows.length === 0
          // ) {
          //   if (doLog())
          //     console.log(
          //       "[CrimeSubmission] checkListFiles before loadGridRows array:",
          //       array
          //     );
          //   this.loadGridRows(array);
          // }
        }
      }
    }
  }

  componentDidMount() {
    if (doLog()) console.log("[CrimeSubmission] componentDidMount");
    this.checkListFiles();
  }

  componentDidUpdate() {
    // if (doLog()) console.log("[CrimeSubmission] componentDidUpdate");
    if (this.state.fieldUpdate) {
      this.setState({ fieldUpdate: false });
    } else {
      if (doLog())
        console.log("[CrimeSubmission] componentDidUpdate state:", this.state);
      if (doLog())
        console.log("[CrimeSubmission] componentDidUpdate props:", this.props);
      if (
        this.state.searching &&
        this.props.error === null &&
        // this.props.result !== null
        hasValue(this.props.result)
      ) {
        if (doLog())
          console.log(
            "[CrimeSubmission] componentDidUpdate result:",
            this.props.result
          );
        const resultMsg = this.props.result[0];
        if (doLog())
          console.log(
            "[CrimeSubmission] componentDidUpdate resultMsg:",
            resultMsg
          );
        if (hasValue(resultMsg)) {
          if (resultMsg.startsWith("ID:")) {
            let incidentID = resultMsg.substring(3);
            let pos = incidentID.indexOf("Complete");
            if (pos === -1) {
              if (doLog())
                console.log(
                  "[CrimeSubmission] componentDidUpdate incidentID:",
                  incidentID
                );
              this.setState({ searching: false, incidentID: incidentID });
            }
          } else if (resultMsg.startsWith("PERSONNELID:")) {
            let personnelID = "-1";
            let personnelName = "";
            const namePos = resultMsg.indexOf("PERSONNELNAME:");
            if (namePos !== -1) {
              personnelID = resultMsg.substring(12, namePos - 1);
              personnelName = resultMsg.substring(namePos + 14);
            } else personnelID = resultMsg.substring(12);
            if (doLog())
              console.log(
                "[CrimeSubmission] componentDidUpdate personnelID:" +
                personnelID +
                " personnelName:" +
                personnelName
              );
            this.setState({
              searching: false,
              personnelID: personnelID,
              personnelName: personnelName,
            });
          }
        }
      }

      this.checkListFiles();
      let processAttachments = false;
      if (
        this.props.attachmentArray !== null &&
        this.props.attachmentArray.length !== 0 &&
        !this.state.reportRunning &&
        !this.props.loading &&
        this.props.upLoadNextIndex < this.props.attachmentArray.length &&
        this.state.incidentID !== null &&
        this.state.currentFile !==
        this.props.attachmentArray[this.props.upLoadNextIndex] &&
        this.props.attachmentArray[this.props.upLoadNextIndex]
          .attachmentFields !== null
      ) {
        processAttachments = true;
        const index = this.props.upLoadNextIndex;
        const ori = this.props.configuration.ori;
        if (doLog())
          console.log(
            "[CrimeSubmission] componentDidUpdate attachmentFields:",
            this.props.attachmentArray[index].attachmentFields
          );
        let id = "-1";
        let contents = "";
        let binaryContents = "";
        let deleted = "";
        if (
          hasValue(this.props.attachmentArray[index].attachmentFields.id.value)
        )
          id = this.props.attachmentArray[index].attachmentFields.id.value;
        if (
          hasValue(
            this.props.attachmentArray[index].attachmentFields.deleted.value
          )
        )
          deleted = this.props.attachmentArray[index].attachmentFields.deleted
            .value;
        if (
          hasValue(
            this.props.attachmentArray[index].attachmentFields.previewUrl
          )
        ) {
          contents = this.props.attachmentArray[index].attachmentFields
            .previewUrl.value;
          const startPos = contents.indexOf(",");
          binaryContents = contents.substring(startPos + 1);
        }
        console.log(
          "[CrimeSubmission] componentDidUpdate binaryContents:",
          binaryContents
        );

        if (deleted === "Y") {
          const transactionType = "DeleteCitizenAttachment";
          const data = {
            id: id,
          };
          const request = {
            transactionType,
            data,
          };
          if (doLog())
            console.log(
              "[CrimeSubmission] componentDidUpdate request:",
              request
            );
          this.setState({ currentFile: this.props.attachmentArray[index] });
          this.props.onRunTransaction(request, this.props.token);
        } else {
          const formData = new FormData();
          formData.append("incidentID", this.state.incidentID);
          formData.append("ori", ori);
          formData.append(
            "fileName",
            this.props.attachmentArray[index].attachmentFields
              .attachmentFileName.value
          );
          formData.append(
            "title",
            this.props.attachmentArray[index].attachmentFields.attachmentTitle
              .value
          );
          formData.append(
            "fileType",
            this.props.attachmentArray[index].attachmentFields
              .attachmentFileType.value
          );
          formData.append("id", id);
          formData.append("contents", binaryContents);
          formData.append("transactionName", "ciddb");
          formData.append("transactionType", "AddCitizenAttachment");

          if (doLog())
            console.log(
              "[CrimeSubmission] componentDidUpdate attachmentsIndex:",
              index
            );
          if (doLog())
            console.log(
              "[CrimeSubmission] componentDidUpdate attachmentFileName:",
              this.props.attachmentArray[index].attachmentFields
                .attachmentFileName.value
            );
          if (doLog())
            console.log(
              "[CrimeSubmission] componentDidUpdate attachmentFields:",
              this.props.attachmentArray[index].attachmentFields
            );
          this.setState({ currentFile: this.props.attachmentArray[index] });
          this.props.onUpLoadFile(formData, this.props.token, index);
        }
      }

      if (
        this.props.reportResult === null &&
        // !uploadingFile &&
        this.state.incidentID !== null &&
        !this.state.reportRunning &&
        !processAttachments &&
        !this.props.loading
        // (this.props.attachmentArray === null || this.props.upLoadNextIndex >= this.props.attachmentArray.length)
      ) {
        if (doLog())
          console.log(
            "[CrimeSubmission] componentDidUpdate request the report"
          );
        const reportAgency = "CitizenWeb";
        const reportUserID = 1;
        const reportORI = this.props.configuration.ori;
        let incidentPrefix = this.props.configuration.incidentPrefix;
        const incidentID = this.state.incidentID;
        const imageWidth = 100;
        const imageHeight = 100;

        if (this.isfbrPermitted()) {
          incidentPrefix = "FBR";
        }

        this.props.onRunReport(
          "citizen_incident_report~pdf~" +
          reportAgency +
          "~" +
          reportUserID +
          "~paramORI|" +
          reportORI +
          "~paramIncidentID|" +
          incidentID +
          "~paramImageWidth|" +
          imageWidth +
          "~paramImageHeight|" +
          imageHeight +
          "~paramIncidentPrefix|" +
          incidentPrefix +
          "~paramIncidentNumber| " +
          "~paramAgencyCode|" +
          this.props.agencyCode +
          "~@OutputFilePrefix|" +
          this.props.agencyCode.toLowerCase() +
          "_" +
          incidentID +
          "_" +
          "~@AddWatermark|" +
          this.props.configuration.waterMarkText,
          true,
          10,
          "RunReports",
          this.props.token
        );
        this.setState({ reportRunning: true });

        //Let the server know we are complete so that XML files can be generated.
        const transactionType = "CitizenIncidentComplete";
        const data = {
          agencyCode: this.props.agencyCode,
          ori: reportORI,
          incidentID: incidentID,
        };
        const request = {
          transactionType,
          data,
        };
        this.props.onRunTransaction(request, this.props.token);
      }

      if (
        this.state.reportRunning &&
        this.props.reportError === null &&
        this.props.reportResult !== null
      ) {
        this.setState({ reportRunning: false, submitting: false });
      }
    }
  }

  handleIncidentDetailsLoad = (id, data) => {
    if (doLog()) console.log("[CrimeSubmission] handleIncidentDetailsLoad");
    if (doLog())
      console.log("[CrimeSubmission] handleIncidentDetailsLoad id:" + id);
    if (this.props.raceList === null) {
      this.props.onFetchMultipleValidCodeLists(
        this.props.configuration.ori,
        this.props.token,
        this.state.validCodeOptions
      );
    } else {
      if (doLog())
        console.log("[CrimeSubmission] handleIncidentDetailsLoad data:", data);
      const typeCode = data.INCIDENTTYPE;
      const selectedData = this.props.incidentTypeDataList.find(
        (option) => option.value === typeCode
      );
      id = data.ID;
      // const index = this.props.incidentTypeList.findIndex(
      //   (option) => option.value === typeCode
      // );
      const index = 0; //The selected type will be put at the top of list
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentDetailsLoad typeCode:",
          typeCode
        );
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentDetailsLoad selectedData:",
          selectedData
        );
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentDetailsLoad index:",
          index
        );
      this.setState({
        incidentType: updateObject(this.state.incidentType, {
          value: typeCode,
          selectedRows: [index],
        }),
        selectedIncidentTypeData: selectedData.data,
        typeCodeChanged: true,
        requiredFieldsComplete: false,
      });
      this.props.onSetIncidentTypeData(selectedData.data);
      this.props.onClearRequiredFieldList();

      this.setState({
        incidentNumber: updateObject(this.state.incidentNumber, {
          value: data.INCIDENTNUMBER,
        }),
        incidentFromDate: updateObject(this.state.incidentFromDate, {
          value: data.FROMDATETIME,
        }),
        incidentToDate: updateObject(this.state.incidentToDate, {
          value: data.TODATETIME,
        }),
        incidentDesc: updateObject(this.state.incidentDesc, {
          value: data.NARRATIVE,
        }),
        //
        firstName: updateObject(this.state.firstName, {
          value: data.FIRSTNAME,
        }),
        middleName: updateObject(this.state.middleName, {
          value: data.MIDDLENAME,
        }),
        lastName: updateObject(this.state.lastName, {
          value: data.LASTNAME,
        }),
        email: updateObject(this.state.email, { value: data.EMAIL }),
        homePhone: updateObject(this.state.homePhone, {
          value: data.HOMEPHONE,
        }),
        cellPhone: updateObject(this.state.cellPhone, {
          value: data.CELLPHONE,
        }),
        workPhone: updateObject(this.state.workPhone, {
          value: data.WORKPHONE,
        }),
        race: updateObject(this.state.race, { value: data.RACE }),
        sex: updateObject(this.state.sex, { value: data.SEX }),
        ethnicity: updateObject(this.state.ethnicity, { value: data.ETHNICITY }),
        dob: updateObject(this.state.dob, {
          value: getMMDDYYYY(data.DOB),
        }),
        oln: updateObject(this.state.oln, { value: data.OLN }),
        olnState: updateObject(this.state.olnState, {
          value: data.OLN_STATE,
        }),
        ssn: updateObject(this.state.ssn, { value: data.SSN }),
        height: updateObject(this.state.height, { value: data.HEIGHT }),
        weight: updateObject(this.state.weight, { value: data.WEIGHT }),
        eyeColor: updateObject(this.state.eyeColor, {
          value: data.EYECOLOR,
        }),
        hairColor: updateObject(this.state.hairColor, {
          value: data.HAIRCOLOR,
        }),
        //
        incidentBusinessName: updateObject(this.state.incidentBusinessName, {
          value: data.INCIDENTBUSINESSNAME,
        }),
        incidentStreetNumber: updateObject(this.state.incidentStreetNumber, {
          value: data.INCIDENTSTREETNUMBER,
        }),
        incidentStreetName: updateObject(this.state.incidentStreetName, {
          value: data.INCIDENTSTREETNAME,
        }),
        incidentApt: updateObject(this.state.incidentApt, {
          value: data.INCIDENTAPARTMENT,
        }),
        incidentCity: updateObject(this.state.incidentCity, {
          value: data.INCIDENTCITY,
        }),
        incidentState: updateObject(this.state.incidentState, {
          value: data.INCIDENTSTATECODE,
        }),
        incidentZip: updateObject(this.state.incidentZip, {
          value: data.INCIDENTPOSTALCODE,
        }),
        timsAddressNumber: updateObject(this.state.timsAddressNumber, {
          value: data.ADDRESSNUMBER,
        }),
        //
        userBusinessName: updateObject(this.state.userBusinessName, {
          value: data.USERBUSINESSNAME,
        }),
        userStreetNumber: updateObject(this.state.userStreetNumber, {
          value: data.USERSTREETNUMBER,
        }),
        userStreetName: updateObject(this.state.userStreetName, {
          value: data.USERSTREETNAME,
        }),
        userApt: updateObject(this.state.userApt, {
          value: data.USERAPARTMENT,
        }),
        userCity: updateObject(this.state.userCity, {
          value: data.USERCITY,
        }),
        userState: updateObject(this.state.userState, {
          value: data.USERSTATECODE,
        }),
        userZip: updateObject(this.state.userZip, {
          value: data.USERPOSTALCODE,
        }),
        //
        towCompanyName: updateObject(this.state.towCompanyName, {
          value: data.TOWCOMPANYNAME,
        }),
        towStreetNumber: updateObject(this.state.towStreetNumber, {
          value: data.TOWSTREETNUMBER,
        }),
        towStreetName: updateObject(this.state.towStreetName, {
          value: data.TOWSTREETNAME,
        }),
        towApt: updateObject(this.state.towApt, {
          value: data.TOWAPARTMENT,
        }),
        towCity: updateObject(this.state.towCity, {
          value: data.TOWCITY,
        }),
        towState: updateObject(this.state.towState, {
          value: data.TOWSTATE,
        }),
        towZip: updateObject(this.state.towZip, { value: data.TOWZIP }),
        id: updateObject(this.state.id, {
          value: id,
        }),
        status: updateObject(this.state.status, { value: data.STATUS }),
      });

      const linkedData = data.LinkedDataItems;
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentDetailsLoad linkedData:",
          linkedData
        );

      const incidentDoc = linkedData.INCIDENTDOC;
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentDetailsLoad incidentDoc:",
          incidentDoc
        );
      if (hasValue(incidentDoc)) {
        if (doLog())
          console.log(
            "[CrimeSubmission] handleIncidentDetailsLoad incidentDoc.length:",
            incidentDoc.length
          );
        let length = 1;
        if (hasValue(incidentDoc.length)) length = incidentDoc.length;
        const attachmentArray = [];
        if (length > 1) {
          for (let i = 0; i < length; i++) {
            const row = incidentDoc[i];
            if (doLog())
              console.log(
                "[CrimeSubmission] handleIncidentDetailsLoad incidentDoc[" +
                i +
                "] row:",
                row
              );
            let docType = "image/jpeg";
            const filename = row.FILENAME;
            if (filename.endsWith(".png")) docType = "image/png";
            else if (filename.endsWith(".pdf")) docType = "application/pdf";
            let contents = row.CONTENTS;
            if (doLog())
              console.log(
                "[CrimeSubmission] handleIncidentDetailsLoad incidentDoc contents:",
                contents
              );
            const baseURL = this.props.baseURL;
            if (doLog())
              console.log(
                "[CrimeSubmission] handleIncidentDetailsLoad incidentDoc baseURL:",
                baseURL
              );
            const attachmentUrl = baseURL + contents;
            const attachmentFields = {
              id: { value: row.ID },
              attachmentFileName: { value: filename },
              attachmentSize: { value: 0 },
              attachmentTitle: { value: row.TITLE },
              attachmentFileType: { value: docType },
              selectedFile: { value: null },
              previewUrl: { value: attachmentUrl },
              deleted: { value: "" },
            };
            if (doLog())
              console.log(
                "[CrimeSubmission] handleIncidentDetailsLoad attachmentFields:",
                attachmentFields
              );
            attachmentArray.push({
              attachmentFields: attachmentFields,
              attachmentInstance: i,
            });
          }
        } else if (length > 0) {
          const row = incidentDoc.ROW;
          if (hasValue(row)) {
            let docType = "image/jpeg";
            const filename = row.FILENAME;
            if (filename.endsWith(".png")) docType = "image/png";
            else if (filename.endsWith(".pdf")) docType = "application/pdf";
            let contents = row.CONTENTS;
            if (doLog())
              console.log(
                "[CrimeSubmission] handleIncidentDetailsLoad incidentDoc contents:",
                contents
              );
            const baseURL = this.props.baseURL;
            if (doLog())
              console.log(
                "[CrimeSubmission] handleIncidentDetailsLoad incidentDoc baseURL:",
                baseURL
              );
            const attachmentUrl = baseURL + contents;
            const attachmentFields = {
              id: { value: row.ID },
              attachmentFileName: { value: filename },
              attachmentSize: { value: 0 },
              attachmentTitle: { value: row.TITLE },
              attachmentFileType: { value: docType },
              selectedFile: { value: null },
              previewUrl: { value: attachmentUrl },
              deleted: { value: "" },
            };
            if (doLog())
              console.log(
                "[CrimeSubmission] handleIncidentDetailsLoad attachmentFields:",
                attachmentFields
              );
            attachmentArray.push({
              attachmentFields: attachmentFields,
              attachmentInstance: 0,
            });
          }
        }
        this.props.onSetAttachmentArray(attachmentArray);
      }

      const incidentName = linkedData.INCIDENTNAME;
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentDetailsLoad incidentName:",
          incidentName
        );
      if (hasValue(incidentName)) {
        if (doLog())
          console.log(
            "[CrimeSubmission] handleIncidentDetailsLoad incidentName.length:",
            incidentName.length
          );
        let incidentNameLength = 1;
        if (hasValue(incidentName.length)) {
          incidentNameLength = incidentName.length;
          if (doLog())
            console.log(
              "[CrimeSubmission] handleIncidentDetailsLoad incidentNameLength:",
              incidentNameLength
            );
        }
        const personArray = [];
        if (incidentNameLength > 1) {
          for (let i = 0; i < incidentNameLength; i++) {
            const row = incidentName[i];
            if (doLog())
              console.log(
                "[CrimeSubmission] handleIncidentDetailsLoad incidentName[" +
                i +
                "] row:",
                row
              );
            let nameType = row.NAMETYPE;
            if (!hasValue(nameType) || nameType === "") nameType = "P";
            const personFields = {
              id: { value: row.ID },
              firstName: { value: row.FIRSTNAME },
              middleName: { value: row.MIDDLENAME },
              lastName: { value: row.LASTNAME },
              // email: { value: row.EMAIL },
              homePhone: { value: row.HOMEPHONE },
              cellPhone: { value: row.CELLPHONE },
              workPhone: { value: row.WORKPHONE },
              dob: { value: getMMDDYYYY(row.DOB) },
              oln: { value: row.OLN },
              olnState: { value: row.OLN_STATE },
              height: { value: row.HEIGHT },
              weight: { value: row.WEIGHT },
              ssn: { value: row.SSN },
              nameType: { value: nameType },
              timsNameID: { value: row.TIMSNAMEID },
              //
              homeStreetNumber: { value: row.HOMESTREETNUMBER },
              homeStreetName: { value: row.HOMESTREETNAME },
              homeApt: { value: row.HOMEAPARTMENT },
              homeCity: { value: row.HOMECITY },
              homeState: { value: row.HOMESTATECODE },
              homeZip: { value: row.HOMEPOSTALCODE },
              //
              workBusinessName: { value: row.WORKBUSINESSNAME },
              workStreetNumber: { value: row.WORKSTREETNUMBER },
              workStreetName: { value: row.WORKSTREETNAME },
              workApt: { value: row.WORKAPARTMENT },
              workCity: { value: row.WORKCITY },
              workState: { value: row.WORKSTATECODE },
              workZip: { value: row.WORKPOSTALCODE },
              //
              personInvolvement: { value: row.INVOLVEMENT },
              race: { value: row.RACE },
              sex: { value: row.SEX },
              ethnicity: { value: row.ETHNICITY },
              eyeColor: { value: row.EYECOLOR },
              hairColor: { value: row.HAIRCOLOR },
              deleted: { value: "" },
            };
            personArray.push({
              personFields: personFields,
              personInstance: i,
            });
          }
        } else if (incidentNameLength > 0) {
          const row = incidentName.ROW;
          if (doLog())
            console.log(
              "[CrimeSubmission] handleIncidentDetailsLoad incidentName row:",
              row
            );
          if (hasValue(row)) {
            let nameType = row.NAMETYPE;
            if (!hasValue(nameType) || nameType === "") nameType = "P";
            const personFields = {
              id: { value: row.ID },
              firstName: { value: row.FIRSTNAME },
              middleName: { value: row.MIDDLENAME },
              lastName: { value: row.LASTNAME },
              // email: { value: row.EMAIL },
              homePhone: { value: row.HOMEPHONE },
              cellPhone: { value: row.CELLPHONE },
              workPhone: { value: row.WORKPHONE },
              dob: { value: getMMDDYYYY(row.DOB) },
              oln: { value: row.OLN },
              olnState: { value: row.OLN_STATE },
              height: { value: row.HEIGHT },
              weight: { value: row.WEIGHT },
              ssn: { value: row.SSN },
              nameType: { value: row.NAMETYPE },
              timsNameID: { value: row.TIMSNAMEID },
              //
              homeStreetNumber: { value: row.HOMESTREETNUMBER },
              homeStreetName: { value: row.HOMESTREETNAME },
              homeApt: { value: row.HOMEAPARTMENT },
              homeCity: { value: row.HOMECITY },
              homeState: { value: row.HOMESTATECODE },
              homeZip: { value: row.HOMEPOSTALCODE },
              //
              workBusinessName: { value: row.WORKBUSINESSNAME },
              workStreetNumber: { value: row.WORKSTREETNUMBER },
              workStreetName: { value: row.WORKSTREETNAME },
              workApt: { value: row.WORKAPARTMENT },
              workCity: { value: row.WORKCITY },
              workState: { value: row.WORKSTATECODE },
              workZip: { value: row.WORKPOSTALCODE },
              //
              personInvolvement: { value: row.INVOLVEMENT },
              race: { value: row.RACE },
              sex: { value: row.SEX },
              ethnicity: { value: row.ETHNICITY },
              eyeColor: { value: row.EYECOLOR },
              hairColor: { value: row.HAIRCOLOR },
              deleted: { value: "" },
            };
            personArray.push({
              personFields: personFields,
              personInstance: 0,
            });
          }
        }
        if (doLog())
          console.log(
            "[CrimeSubmission] handleIncidentDetailsLoad incidentName new personArray:",
            personArray
          );
        this.props.onSetPersonArray(personArray);
      }

      const incidentProperty = linkedData.INCIDENTPROPERTY;
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentDetailsLoad incidentProperty:",
          incidentProperty
        );
      if (hasValue(incidentProperty)) {
        if (doLog())
          console.log(
            "[CrimeSubmission] handleIncidentDetailsLoad incidentProperty.length:",
            incidentProperty.length
          );
        let length = 1;
        if (hasValue(incidentProperty.length)) length = incidentProperty.length;
        const propertyArray = [];
        if (length > 1) {
          for (let i = 0; i < length; i++) {
            const row = incidentProperty[i];
            if (doLog())
              console.log(
                "[CrimeSubmission] handleIncidentDetailsLoad incidentProperty[" +
                i +
                "] row:",
                row
              );
            const propertyFields = {
              id: { value: row.ID },
              propertyType: { value: row.PROPERTYCLASS },
              propertyColor: { value: row.COLOR1 },
              propertyDescription: { value: row.DESCRIPTION },
              propertyMake: { value: row.MAKE },
              propertyModel: { value: row.MODEL },
              propertySerialNo: { value: row.SERIALNUMBER },
              propertyQuantity: { value: row.QUANTITY },
              propertyMarketValue: { value: 0 },
              propertyDamagedValue: { value: 0 },
              deleted: { value: "" },
            };
            propertyArray.push({
              propertyFields: propertyFields,
              propertyInstance: i,
            });
          }
        } else if (length > 0) {
          const row = incidentProperty.ROW;
          if (doLog())
            console.log(
              "[CrimeSubmission] handleIncidentDetailsLoad incidentProperty row:",
              row
            );
          if (hasValue(row)) {
            const propertyFields = {
              id: { value: row.ID },
              propertyType: { value: row.PROPERTYCLASS },
              propertyColor: { value: row.COLOR1 },
              propertyDescription: { value: row.DESCRIPTION },
              propertyMake: { value: row.MAKE },
              propertyModel: { value: row.MODEL },
              propertySerialNo: { value: row.SERIALNUMBER },
              propertyQuantity: { value: row.QUANTITY },
              propertyMarketValue: { value: 0 },
              propertyDamagedValue: { value: 0 },
              deleted: { value: "" },
            };
            propertyArray.push({
              propertyFields: propertyFields,
              propertyInstance: 0,
            });
          }
        }
        this.props.onSetPropertyArray(propertyArray);
      }

      const incidentVehicle = linkedData.INCIDENTVEHICLE;
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentDetailsLoad incidentVehicle:",
          incidentVehicle
        );
      if (hasValue(incidentVehicle)) {
        const vehicleArray = [];
        if (doLog())
          console.log(
            "[CrimeSubmission] handleIncidentDetailsLoad incidentVehicle.length:",
            incidentVehicle.length
          );
        let length = 1;
        if (hasValue(incidentVehicle.length)) length = incidentVehicle.length;
        if (length > 1) {
          for (let i = 0; i < length; i++) {
            const row = incidentVehicle[i];
            if (doLog())
              console.log(
                "[CrimeSubmission] handleIncidentDetailsLoad incidentVehicle[" +
                i +
                "] row:",
                row
              );
            const vehicleFields = {
              id: { value: row.ID },
              vehicleInvolvement: { value: row.INVOLVEMENT },
              vehicleDescription: { value: row.DESCRIPTION },
              vehicleMake: { value: row.MAKE },
              vehicleModel: { value: row.MODEL },
              vehicleColor1: { value: row.COLOR1 },
              vehicleBodyStyle: { value: row.BODYSTYLE },
              vehicleYear: { value: row.VEHICLEYEAR },
              vehiclePlateTag: { value: row.PLATETAG },
              vehicleStateCode: { value: row.STATECODE },
              vehicleVIN: { value: row.VIN },
              vehicleDamageValue: { value: row.DAMAGEVALUE },
              vehicleInsuranceCompany: { value: row.INSURANCECOMPANY },
              vehiclePolicyHolder: { value: row.POLICYHOLDER },
              vehiclePolicyNumber: { value: row.POLICYNUMBER },
              deleted: { value: "" },
            };
            vehicleArray.push({
              vehicleFields: vehicleFields,
              vehicleInstance: i,
            });
          }
        } else if (length > 0) {
          const row = incidentVehicle.ROW;
          if (doLog())
            console.log(
              "[CrimeSubmission] handleIncidentDetailsLoad incidentVehicle row:",
              row
            );
          if (hasValue(row)) {
            const vehicleFields = {
              id: { value: row.ID },
              vehicleInvolvement: { value: row.INVOLVEMENT },
              vehicleDescription: { value: row.DESCRIPTION },
              vehicleMake: { value: row.MAKE },
              vehicleModel: { value: row.MODEL },
              vehicleColor1: { value: row.COLOR1 },
              vehicleBodyStyle: { value: row.BODYSTYLE },
              vehicleYear: { value: row.VEHICLEYEAR },
              vehiclePlateTag: { value: row.PLATETAG },
              vehicleStateCode: { value: row.STATECODE },
              vehicleVIN: { value: row.VIN },
              vehicleDamageValue: { value: row.DAMAGEVALUE },
              vehicleInsuranceCompany: { value: row.INSURANCECOMPANY },
              vehiclePolicyHolder: { value: row.POLICYHOLDER },
              vehiclePolicyNumber: { value: row.POLICYNUMBER },
              deleted: { value: "" },
            };
            vehicleArray.push({
              vehicleFields: vehicleFields,
              vehicleInstance: 0,
            });
          }
        }
        this.props.onSetVehicleArray(vehicleArray);
      }
      this.setState({ incidentDetailsLoaded: true });
    }
  };

  handleIncidentTypeChange = (fieldName, param, event) => {
    if (doLog())
      console.log("[CrimeSubmission] handleIncidentTypeChange param:", param);
    if (doLog())
      console.log("[CrimeSubmission] handleIncidentTypeChange event:", event);
    if (doLog())
      console.log(
        "[CrimeSubmission] handleIncidentTypeChange props:",
        this.props
      );
    if (param != null && param.row != null && param.id !== -1) {
      const row = param.row;
      const typeCode = row.typeCode;
      const selectedData = this.props.incidentTypeDataList.find(
        (option) => option.value === typeCode
      );
      const obj = this.props.incidentTypeList.find(
        (option) => option.value === typeCode
      );
      const index = this.props.incidentTypeList.findIndex(
        (option) => option.value === typeCode
      );
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentTypeChange typeCode:",
          typeCode
        );
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentTypeChange selectedData:",
          selectedData
        );
      if (doLog())
        console.log("[CrimeSubmission] handleIncidentTypeChange obj:", obj);
      this.setState({
        incidentType: updateObject(this.state.incidentType, {
          value: typeCode,
          selectedRows: [index],
        }),
        selectedIncidentTypeData: selectedData.data,
        typeCodeChanged: true,
        requiredFieldsComplete: false,
      });
      this.props.onSetIncidentTypeData(selectedData.data);
      this.props.onClearRequiredFieldList();
    } else {
      this.setState({
        incidentType: updateObject(this.state.incidentType, {
          value: "",
          labelValue: null,
          selectedRows: [-1],
        }),
        selectedIncidentTypeData: null,
      });
      this.props.onSetIncidentTypeData(null);
    }
  };

  handleIncidentTypeCheckbox = (fieldName, newSelectionModel) => {
    if (doLog())
      console.log(
        "[CrimeSubmission] handleIncidentTypeCheckbox newSelectionModel:",
        newSelectionModel
      );
    if (doLog())
      console.log(
        "[CrimeSubmission] handleIncidentTypeCheckbox props:",
        this.props
      );
    if (newSelectionModel != null && newSelectionModel[1] != null) {
      const index = newSelectionModel[1];
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentTypeCheckbox index:",
          index
        );
      let selectedRow = -1;
      if (hasValue(this.state.incidentType.selectedRows)) {
        selectedRow = this.state.incidentType.selectedRows[0];
      }
      if (doLog())
        console.log(
          "[CrimeSubmission] handleIncidentTypeCheckbox selectedRow:" +
          selectedRow
        );
      if (selectedRow !== index && index >= 0) {
        const typeCode = this.props.incidentTypeDataList[index].value;
        const selectedData = this.props.incidentTypeDataList.find(
          (option) => option.value === typeCode
        );
        if (doLog())
          console.log(
            "[CrimeSubmission] handleIncidentTypeCheckbox typeCode:",
            typeCode
          );
        if (doLog())
          console.log(
            "[CrimeSubmission] handleIncidentTypeCheckbox selectedData:",
            selectedData
          );
        this.setState({
          incidentType: updateObject(this.state.incidentType, {
            value: typeCode,
            selectedRows: [index],
          }),
          selectedIncidentTypeData: selectedData.data,
          typeCodeChanged: true,
          requiredFieldsComplete: false,
        });
        this.props.onSetIncidentTypeData(selectedData.data);
        this.props.onClearRequiredFieldList();
      }
    }
  };

  handleNewIncidentButton = () => {
    if (doLog()) console.log("[CrimeSubmission] handleNewIncidentButton");
    //Clear all fields except for the user fields
    //Clear the pdf report area
    this.props.onClearReportResult();
    this.updateFieldValueState("id", "-1");
    this.updateFieldValueState("incidentType", "");
    this.updateFieldValueState("incidentDesc", "");
    this.updateFieldValueState(
      "incidentFromDate",
      moment().format("MM/DD/YYYY hh:mm A")
    );
    this.updateFieldValueState(
      "incidentToDate",
      moment().format("MM/DD/YYYY hh:mm A")
    );
    this.updateFieldValueState("incidentBusinessName", "");
    this.updateFieldValueState("incidentStreetNumber", "");
    this.updateFieldValueState("incidentStreetName", "");
    this.updateFieldValueState("incidentApt", "");
    this.updateFieldValueState("incidentCity", "");
    this.updateFieldValueState("incidentState", "");
    this.updateFieldValueState("incidentZip", "");
    this.updateFieldValueState("userBusinessName", "");
    this.updateFieldValueState("userStreetNumber", "");
    this.updateFieldValueState("userStreetName", "");
    this.updateFieldValueState("userApt", "");
    this.updateFieldValueState("userCity", "");
    this.updateFieldValueState("userState", "");
    this.updateFieldValueState("userZip", "");
    this.updateFieldValueState("timsAddressNumber", null);
    //
    this.updateFieldValueState("towCompanyName", "");
    this.updateFieldValueState("towStreetNumber", "");
    this.updateFieldValueState("towStreetName", "");
    this.updateFieldValueState("towApt", "");
    this.updateFieldValueState("towCity", "");
    this.updateFieldValueState("towState", "");
    this.updateFieldValueState("towZip", "");
    //
    this.updateFieldValueState("status", "");
    //
    this.props.onSetIncidentTypeData(null);
    this.props.onSetAttachmentArray([]);
    this.props.onSetPersonArray([]);
    this.props.onSetPropertyArray([]);
    this.props.onSetVehicleArray([]);
    //
    this.setState({
      currentFile: null,
      incidentID: null,
      reportRunning: false,
      attachmentsRunning: false,
      useSameAddress: false,
    });
    this.props.onClearUpLoadResult();
  };

  handleIncidentRowClick = (param, event) => {
    if (doLog())
      console.log("[CrimeSubmission] handleIncidentRowClick param:", param);
    if (doLog())
      console.log("[CrimeSubmission] handleIncidentRowClick event:", event);
    if (param != null && param.row != null) {
      const array = this.props.result.RESULT.CITIZENINCIDENT;
      const row = param.row;
      let item = null;
      if (hasValue(array.length)) item = array[row.id];
      else item = array;
      if (doLog())
        console.log("[CrimeSubmission] handleIncidentRowClick item:", item);
      const ori = item.ORI;
      const id = item.ID;
      const typeCode = item.INCIDENTTYPE;
      const selectedData = this.props.incidentTypeDataList.find(
        (option) => option.value === typeCode
      );
      this.setState({
        incidentDetailsLoaded: false,
        id: updateObject(this.state.id, {
          value: id,
        }),
        incidentType: updateObject(this.state.incidentType, {
          value: typeCode,
          selectedRows: [0],
        }),
        selectedIncidentTypeData: selectedData.data,
      });
      if (doLog())
        console.log("[CrimeSubmission] handleIncidentRowClick item:", item);
      this.props.onFetchIncidentDetails(this.props.token, ori, id);
      this.loadIncidentTypeList(typeCode, selectedData.data, true);
    }
  };

  handleSearchLocationRowClick = (param, event) => {
    if (doLog())
      console.log(
        "[CrimeSubmission] handleSearchLocationRowClick param:",
        param
      );
    if (doLog())
      console.log(
        "[CrimeSubmission] handleSearchLocationRowClick event:",
        event
      );
    if (param != null && param.row != null) {
      const array = this.props.result.RESULT.ADDRESS;
      const row = param.row;
      let item = null;
      if (hasValue(array.length)) item = array[row.id];
      else item = array;
      if (doLog())
        console.log(
          "[CrimeSubmission] handleSearchLocationRowClick item:",
          item
        );
      this.setState({
        incidentStreetNumber: updateObject(this.state.incidentStreetNumber, {
          value: item.STREETNUMBER,
        }),
        incidentStreetName: updateObject(this.state.incidentStreetName, {
          value: item.STREETNAME,
        }),
        incidentApt: updateObject(this.state.incidentApt, {
          value: item.APARTMENT,
        }),
        incidentCity: updateObject(this.state.incidentCity, {
          value: item.CITY,
        }),
        incidentState: updateObject(this.state.incidentState, {
          value: item.STATECODE,
        }),
        incidentZip: updateObject(this.state.incidentZip, {
          value: item.POSTALCODE,
        }),
        incidentBusinessName: updateObject(this.state.incidentBusinessName, {
          value: item.COMMONNAME,
        }),
        timsAddressNumber: updateObject(this.state.timsAddressNumber, {
          value: item.ADDRESSNUMBER,
        }),
      });
    }
  };

  handleSearchIncident = () => {
    if (doLog()) console.log("[CrimeSubmission] handleSearchIncident");
    this.setState({ runIncidentSearch: true });
    this.props.onClearTransactionResult();
    this.props.onClearTransDesc();
    // let statusOption =
    //   " AND (CITIZENINCIDENT.STATUS IS NULL OR CITIZENINCIDENT.STATUS = '' OR CITIZENINCIDENT.STATUS = 'response')";
    let deletedOption =
      " AND (CITIZENINCIDENT.DELETEDFLAG IS NULL OR CITIZENINCIDENT.DELETEDFLAG <> 'Y')";
    // if (this.state.includeProcessed) {
    const statusOption = "";
    // }
    let dateOption = "";
    const fromDate = this.state.paramStartDate.value;
    const endDate = this.state.paramEndDate.value;
    if (doLog())
      console.log("[CrimeSubmission] componentDidUpdate fromDate:", fromDate);
    if (doLog())
      console.log("[CrimeSubmission] componentDidUpdate endDate:", endDate);
    if (hasValue(fromDate) && fromDate.length > 0)
      dateOption +=
        " AND (IncidentDateTime >= '" + getYYYYMMDD(fromDate) + " 00:00:00')";
    if (hasValue(endDate) && endDate.length > 0)
      dateOption +=
        " AND (IncidentDateTime <= '" + getYYYYMMDD(endDate) + " 23:59:59')";
    const transactionType =
      '<CIDDB><QUERY TABLE="CitizenIncident"' +
      ' WHERE="CITIZENINCIDENT.ORI=' +
      singleQuote +
      this.props.configuration.ori +
      singleQuote +
      " AND IncidentNumber LIKE 'FBR%'" +
      " AND TIMSReportingOfficerID = " +
      this.state.personnelID +
      dateOption +
      statusOption +
      deletedOption +
      quote +
      ' LIMIT="9999" OPERATORID="' +
      this.props.userId +
      '1"><FIELD_LIST>ALL</FIELD_LIST><ORDER_BY><INCIDENTNUMBER/></ORDER_BY>' +
      '<JOIN TABLE="CitizenIncidentType" OUTER="TRUE">' +
      "<FIELD_LIST><DESCRIPTION/></FIELD_LIST>" +
      '<ON><ORI SEARCH_TYPE="equal_to"><PARENT_FIELD>ORI</PARENT_FIELD></ORI></ON>' +
      '<ON><IncidentType SEARCH_TYPE="equal_to"><PARENT_FIELD>IncidentType</PARENT_FIELD></IncidentType></ON>' +
      "</JOIN>" +
      "</QUERY></CIDDB>";
    if (doLog())
      console.log(
        "[CrimeSubmission] componentDidUpdate transactionType:",
        transactionType
      );
    const data = {};
    const request = {
      transactionType,
      data,
    };
    // this.setState({ incidentSearching: true });
    this.props.onRunTransaction(request, this.props.token, "incidentList");
  };

  handleSearchLocationTIMS = () => {
    if (doLog()) console.log("[CrimeSubmission] handleSearchLocationTIMS");
    this.setState({ runTIMSSearch: true });
    this.props.onClearTransactionResult();
    this.props.onClearTransDesc();
    let transactionType =
      '<CIDDB><QUERY TABLE="Address" LIMIT="100">' +
      "  <FIELD_LIST>ALL</FIELD_LIST>" +
      "  <WHERE>";
    if (hasValue(this.state.incidentBusinessNameSearch.value))
      transactionType +=
        '    <CommonName SEARCH_TYPE="LIKE">' +
        "      <SEARCH_VALUE>" +
        this.state.incidentBusinessNameSearch.value +
        "%</SEARCH_VALUE>" +
        "    </CommonName>";

    if (hasValue(this.state.incidentStreetNumberSearch.value))
      transactionType +=
        '    <StreetNumber SEARCH_TYPE="LIKE">' +
        "      <SEARCH_VALUE>" +
        this.state.incidentStreetNumberSearch.value +
        "%</SEARCH_VALUE>" +
        "    </StreetNumber>";
    if (hasValue(this.state.incidentStreetNameSearch.value))
      transactionType +=
        '    <StreetName SEARCH_TYPE="LIKE">' +
        "      <SEARCH_VALUE>" +
        this.state.incidentStreetNameSearch.value +
        "%</SEARCH_VALUE>" +
        "    </StreetName>";
    if (hasValue(this.state.incidentAptSearch.value))
      transactionType +=
        '    <Apartment SEARCH_TYPE="equal_to">' +
        "      <SEARCH_VALUE>" +
        this.state.incidentAptSearch.value +
        "</SEARCH_VALUE>" +
        "    </Apartment>";
    if (hasValue(this.state.incidentCitySearch.value))
      transactionType +=
        '    <City SEARCH_TYPE="LIKE">' +
        "      <SEARCH_VALUE>" +
        this.state.incidentCitySearch.value +
        "%</SEARCH_VALUE>" +
        "    </City>";
    if (hasValue(this.state.incidentStateSearch.value))
      transactionType +=
        '    <StateCode SEARCH_TYPE="LIKE">' +
        "      <SEARCH_VALUE>" +
        this.state.incidentStateSearch.value +
        "%</SEARCH_VALUE>" +
        "    </StateCode>";
    if (hasValue(this.state.incidentZipSearch.value))
      transactionType +=
        '    <PostalCode SEARCH_TYPE="equal_to">' +
        "      <SEARCH_VALUE>" +
        this.state.incidentZipSearch.value +
        "</SEARCH_VALUE>" +
        "    </PostalCode>";
    transactionType +=
      "  </WHERE>" +
      "  <ORDER_BY>" +
      "    <StreetName/>" +
      "    <StreetNumber/>" +
      "  </ORDER_BY>" +
      "</QUERY></CIDDB>";
    const data = {};
    const request = {
      transactionType,
      data,
    };
    this.props.onRunTransaction(request, this.props.token, "LocationList");
  };

  handleSendButton = () => {
    // if (doLog()) console.log("[CrimeSubmission] handleSendButton");
    if (doLog())
      console.log("[CrimeSubmission] handleSendButton state:", this.state);
    if (doLog())
      console.log("[CrimeSubmission] handleSendButton props:", this.props);
    // const connectionName = this.props.configuration.ciddbConnectionName;
    const ori = this.props.configuration.ori;
    const transactionType = "AddCitizenIncident";
    let propertyData = this.handleSendPropertyData();
    let vehicleData = this.handleSendVehicleData();
    let personData = this.handleSendPersonData();
    const data = {
      ori: ori,
      id: this.state.id.value,
      personInvolvement: this.state.personInvolvement.value,
      firstName: this.state.firstName.value,
      middleName: this.state.middleName.value,
      lastName: this.state.lastName.value,
      email: this.state.email.value,
      homePhone: this.state.homePhone.value,
      cellPhone: this.state.cellPhone.value,
      workPhone: this.state.workPhone.value,
      race: this.state.race.value,
      sex: this.state.sex.value,
      ethnicity: this.state.ethnicity.value,
      dob: this.state.dob.value,
      oln: this.state.oln.value,
      olnState: this.state.olnState.value,
      ssn: this.state.ssn.value,
      height: this.state.height.value,
      weight: this.state.weight.value,
      eyeColor: this.state.eyeColor.value,
      hairColor: this.state.hairColor.value,
      //
      incidentNumber: this.state.incidentNumber.value,
      incidentType: this.state.incidentType.value,
      incidentDesc: this.state.incidentDesc.value,
      // incidentReportDate: this.state.incidentReportDate.value,
      incidentFromDate: this.state.incidentFromDate.value,
      incidentToDate: this.state.incidentToDate.value,
      incidentBusinessName: this.state.incidentBusinessName.value,
      incidentStreetNumber: this.state.incidentStreetNumber.value,
      incidentStreetName: this.state.incidentStreetName.value,
      incidentApt: this.state.incidentApt.value,
      incidentCity: this.state.incidentCity.value,
      incidentState: this.state.incidentState.value,
      incidentZip: this.state.incidentZip.value,
      userBusinessName: this.state.userBusinessName.value,
      userStreetNumber: this.state.userStreetNumber.value,
      userStreetName: this.state.userStreetName.value,
      userApt: this.state.userApt.value,
      userCity: this.state.userCity.value,
      userState: this.state.userState.value,
      userZip: this.state.userZip.value,
      timsAddressNumber: this.state.timsAddressNumber.value,
      timsReportingOfficerID: this.state.personnelID,
      //
      towCompanyName: this.state.towCompanyName.value,
      towStreetNumber: this.state.towStreetNumber.value,
      towStreetName: this.state.towStreetName.value,
      towApt: this.state.towApt.value,
      towCity: this.state.towCity.value,
      towState: this.state.towState.value,
      towZip: this.state.towZip.value,
      //
      status: this.state.status.value,
      //
      propertyData: propertyData,
      vehicleData: vehicleData,
      personData: personData,
    };
    const request = {
      transactionType,
      data,
    };

    if (doLog())
      console.log("[CrimeSubmission] handleSendButton request:", request);
    // if (doLog()) console.log("[handleSendButton] string request:", JSON.stringify(request));
    this.setState({ searching: true, submitting: true, attachmentsIndex: 0 });
    this.props.onRunTransaction(request, this.props.token);
  };

  handleSendPersonData() {
    if (doLog())
      console.log(
        "[CrimeSubmission] handleSendPersonData personArray:",
        this.props.personArray
      );
    let personData = [];
    if (
      this.props.personArray &&
      this.props.personArray !== null &&
      this.props.personArray.length > 0
    ) {
      for (let i = 0; i < this.props.personArray.length; i++) {
        const array = this.props.personArray[i].personFields;
        if (array !== null) {
          const fields = {
            id: array.id.value,
            personInvolvement: array.personInvolvement.value,
            nameType: array.nameType.value,
            timsNameID: array.timsNameID.value,
            firstName: array.firstName.value,
            middleName: array.middleName.value,
            lastName: array.lastName.value,
            // email: array.email.value,
            homePhone: array.homePhone.value,
            cellPhone: array.cellPhone.value,
            workPhone: array.workPhone.value,
            race: array.race.value,
            sex: array.sex.value,
            ethnicity: array.ethnicity.value,
            dob: array.dob.value,
            oln: array.oln.value,
            olnState: array.olnState.value,
            ssn: array.ssn.value,
            height: array.height.value,
            weight: array.weight.value,
            eyeColor: array.eyeColor.value,
            hairColor: array.hairColor.value,
            //
            homeStreetNumber: array.homeStreetNumber.value,
            homeStreetName: array.homeStreetName.value,
            homeApt: array.homeApt.value,
            homeCity: array.homeCity.value,
            homeState: array.homeState.value,
            homeZip: array.homeZip.value,
            //
            workBusinessName: array.workBusinessName.value,
            workStreetNumber: array.workStreetNumber.value,
            workStreetName: array.workStreetName.value,
            workApt: array.workApt.value,
            workCity: array.workCity.value,
            workState: array.workState.value,
            workZip: array.workZip.value,
            deleted: array.deleted.value,
          };
          personData.push(fields);
        }
      }
    }
    return personData;
  }

  handleSendPropertyData() {
    if (doLog())
      console.log(
        "[CrimeSubmission] handleSendPropertyData propertyArray:",
        this.props.propertyArray
      );
    let propertyData = [];
    if (
      this.props.propertyArray &&
      this.props.propertyArray !== null &&
      this.props.propertyArray.length > 0
    ) {
      for (let i = 0; i < this.props.propertyArray.length; i++) {
        const array = this.props.propertyArray[i].propertyFields;
        if (array !== null) {
          const fields = {
            id: array.id.value,
            propertyDescription: array.propertyDescription.value,
            propertyType: array.propertyType.value,
            propertyMake: array.propertyMake.value,
            propertyModel: array.propertyModel.value,
            propertySerialNo: array.propertySerialNo.value,
            propertyColor: array.propertyColor.value,
            propertyQuantity: array.propertyQuantity.value,
            propertyMarketValue: array.propertyMarketValue.value,
            propertyDamagedValue: array.propertyDamagedValue.value,
            deleted: array.deleted.value,
          };
          propertyData.push(fields);
        }
      }
    }
    return propertyData;
  }

  handleSendVehicleData() {
    if (doLog())
      console.log(
        "[CrimeSubmission] handleSendVehicleData  vehicleArray:",
        this.props.vehicleArray
      );
    let vehicleData = [];
    if (
      this.props.vehicleArray &&
      this.props.vehicleArray !== null &&
      this.props.vehicleArray.length > 0
    ) {
      for (let i = 0; i < this.props.vehicleArray.length; i++) {
        const array = this.props.vehicleArray[i].vehicleFields;
        if (array !== null) {
          const fields = {
            id: array.id.value,
            vehicleInvolvement: array.vehicleInvolvement.value,
            vehicleDescription: array.vehicleDescription.value,
            vehicleYear: array.vehicleYear.value,
            vehiclePlateTag: array.vehiclePlateTag.value,
            vehicleStateCode: array.vehicleStateCode.value,
            vehicleVIN: array.vehicleVIN.value,
            vehicleBodyStyle: array.vehicleBodyStyle.value,
            vehicleMake: array.vehicleMake.value,
            vehicleModel: array.vehicleModel.value,
            vehicleColor1: array.vehicleColor1.value,
            vehicleDamageValue: array.vehicleDamageValue.value,
            vehicleInsuranceCompany: array.vehicleInsuranceCompany.value,
            vehiclePolicyHolder: array.vehiclePolicyHolder.value,
            vehiclePolicyNumber: array.vehiclePolicyNumber.value,
            deleted: array.deleted.value,
          };
          vehicleData.push(fields);
        }
      }
    }
    return vehicleData;
  }

  handleSameAddressCheckBox = () => (event) => {
    this.setState({ useSameAddress: event.target.checked });
    if (event.target.checked) {
      this.setState({
        userBusinessName: this.state.incidentBusinessName,
        userStreetNumber: this.state.incidentStreetNumber,
        userStreetName: this.state.incidentStreetName,
        userApt: this.state.incidentApt,
        userCity: this.state.incidentCity,
        userZip: this.state.incidentZip,
      });
    }
  };

  isfbrPermitted() {
    let fbrPermitted = false;
    if (this.state.fbrMode === null) {
      const appOptions = getAppOptions();
      if (doLog()) console.log("CrimeSubmission appOptions:", appOptions);
      const permissionOption = appOptions["fbr"];
      if (
        hasValue(permissionOption) &&
        permissionOption.toUpperCase().startsWith("T")
      ) {
        fbrPermitted = true;
      }
      this.setState({ fbrMode: fbrPermitted });
    } else fbrPermitted = this.state.fbrMode;

    if (doLog()) console.log("CrimeSubmission permitted:", fbrPermitted);
    return fbrPermitted;
  }

  loadGridRows = (array) => {
    if (doLog()) console.log("[CrimeSubmission] loadGridRows array:", array);
    const selectedRows = this.state.incidentType.selectedRows;
    const listRows = [];
    listRows.push({
      id: -1,
      description: "Select a type",
      definition: "",
      examples: "",
      typeCode: "",
    });

    if (array !== null) {
      if (doLog()) console.log("[CrimeSubmission] array:", array);
      for (let i = 0; i < array.length; i++) {
        const fields = array[i].data;
        listRows.push({
          id: i,
          description: fields.DESCRIPTION,
          definition: fields.DEFINITION,
          examples: fields.EXAMPLES,
          typeCode: fields.INCIDENTTYPE,
        });
      }
    }
    const gridColumns = [
      {
        field: "description",
        renderHeader: (params) => <strong>{"Description"}</strong>,
        width: 300,
      },
      {
        field: "definition",
        renderHeader: (params) => <strong>{"Definition"}</strong>,
        width: 200,
        // flex: 2
      },
      {
        field: "examples",
        renderHeader: (params) => <strong>{"Examples"}</strong>,
        width: 200,
      },
      // {
      //   field: "typeCode",
      //   renderHeader: (params) => <strong>{"Type Code"}</strong>,
      //   width: 100,
      // },
    ];

    this.setState({
      incidentType: updateObject(this.state.incidentType, {
        gridDefaultRows: listRows,
        gridRows: listRows,
        gridColumns: gridColumns,
        selectedRows: selectedRows,
      }),
    });
  };

  loadIncidentTypeList(typeCode, selectedTypeData, fromIncidentSelect) {
    let array = [];
    // if (doLog())
    //   console.log("[CrimeSubmission] loadIncidentTypeList typeCode:", typeCode);
    // if (doLog())
    //   console.log("[CrimeSubmission] loadIncidentTypeList selectedTypeData:", selectedTypeData);
    // if (doLog())
    //   console.log("[CrimeSubmission] loadIncidentTypeList incidentTypeList:", this.props.incidentTypeList);
    if (hasValue(this.props.incidentTypeList) && (!fromIncidentSelect || hasValue(typeCode))) {
      const selectedTypeCode = typeCode;
      const selectedIncidentTypeData = {
        value: selectedTypeCode,
        data: selectedTypeData,
      };
      if (doLog())
        console.log(
          "[CrimeSubmission] loadIncidentTypeList selectedTypeCode:" +
          selectedTypeCode +
          " selectedIncidentTypeData:",
          selectedIncidentTypeData
        );
      if (hasValue(selectedTypeCode)) {
        array.push(selectedIncidentTypeData);
      }

      for (let i = 0; i < this.props.incidentTypeDataList.length; i++) {
        const row = this.props.incidentTypeDataList[i];
        let permitted = false;
        if (row !== null) {
          if (
            !hasValue(selectedTypeCode) ||
            selectedTypeCode !== row.data.INCIDENTTYPE
          ) {
            permitted = true;
            if (doLog())
              console.log(
                "[CrimeSubmission] loadIncidentTypeList row[" + i + "]:",
                row
              );
            const permission = row.data.PERMISSIONNAME;
            if (hasValue(permission) && typeof permission === "string") {
              if (doLog())
                console.log(
                  "[CrimeSubmission] loadIncidentTypeList incident type of " +
                  row.data.INCIDENTTYPE +
                  " permission needed:",
                  permission
                );
              permitted = false;
              const appOptions = getAppOptions(permission);
              // console.log("[CrimeSubmission] appOptions:", appOptions);
              const permissionValue = appOptions[permission];
              if (doLog())
                console.log(
                  "[CrimeSubmission] loadIncidentTypeList permissionValue:",
                  permissionValue
                );
              if (
                hasValue(permissionValue) &&
                permissionValue.toUpperCase().startsWith("T")
              ) {
                permitted = true;
              }
            }
          } else permitted = false;
        }
        if (permitted) {
          array.push(row);
        }
      }

      if (doLog())
        console.log("[CrimeSubmission] loadIncidentTypeList gridDefaultRows.length:", this.state.incidentType.gridDefaultRows.length);
      if (
        array !== null &&
        array.length > 0 &&
        (this.state.incidentType.gridDefaultRows.length === 0 || fromIncidentSelect)
      ) {
        if (doLog())
          console.log(
            "[CrimeSubmission] loadIncidentTypeList before loadGridRows array:",
            array
          );
        this.loadGridRows(array);
      }
    }
  }

  setDefaultStateCode() {
    if (
      this.props.configuration.ori !== "" &&
      !this.props.multipleListLoading &&
      (this.state.incidentState.value === null ||
        this.state.incidentState.value === "")
    ) {
      if (doLog()) console.log("[CrimeSubmission] setDefaultStateCode");
      const ori = this.props.configuration.ori;
      const stateCode = ori.substring(0, 2);
      this.setState({
        incidentState: updateObject(this.state.incidentState, {
          value: stateCode,
        }),
        olnState: updateObject(this.state.olnState, {
          value: stateCode,
        }),
        userState: updateObject(this.state.userState, {
          value: stateCode,
        }),
        towState: updateObject(this.state.towState, {
          value: stateCode,
        }),
        incidentStateSearch: updateObject(this.state.incidentStateSearch, {
          value: stateCode,
        }),
      });
    }
  }

  setFieldRequiredSettings(sectionName) {
    if (doLog())
      console.log(
        "[CrimeSubmission] setFieldRequiredSettings sectionName:",
        sectionName
      );
    if (doLog())
      console.log(
        "[CrimeSubmission] setFieldRequiredSettings requiredFieldList:",
        this.props.requiredFieldList
      );
    if (sectionName === "Tow" || this.isfbrPermitted)
      this.setFieldRequiredSettingsOff("User");
    if (sectionName === "User") this.setFieldRequiredSettingsOff("Tow");

    for (let field in this.state.mappedTextPropFields) {
      const fieldName = this.state.mappedTextPropFields[field];
      if (doLog())
        console.log(
          "[CrimeSubmission] setFieldRequiredSettings text field:",
          fieldName
        );
      if (this.getFieldRequiredFoundInSection(fieldName, sectionName)) {
        const required = this.getFieldRequiredStatus(fieldName, sectionName);
        const requiredOption = { required: required };
        // if (doLog()) console.log(
        //   "[CrimeSubmission] setFieldRequiredSettings text field:",
        //   fieldName
        // );
        if (doLog())
          console.log(
            "[CrimeSubmission] setFieldRequiredSettings required:",
            required
          );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            validation: requiredOption,
          }),
        });
      }
    }

    for (let field in this.state.mappedSelectPropFields) {
      const fieldName = this.state.mappedSelectPropFields[field];
      if (this.getFieldRequiredFoundInSection(fieldName, sectionName)) {
        const required = this.getFieldRequiredStatus(fieldName, sectionName);
        const requiredOption = { required: required };
        if (doLog())
          console.log(
            "[CrimeSubmission] setFieldRequiredSettings select field:",
            fieldName
          );
        if (doLog())
          console.log(
            "[CrimeSubmission] setFieldRequiredSettings select required:",
            required
          );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            validation: requiredOption,
          }),
        });
      }
    }
  }

  setFieldRequiredSettingsOff(sectionName) {
    if (doLog())
      console.log(
        "[CrimeSubmission] setFieldRequiredSettingsOff   sectionName:",
        sectionName
      );
    for (let field in this.state.mappedTextPropFields) {
      const fieldName = this.state.mappedTextPropFields[field];
      if (this.getFieldRequiredFoundInSection(fieldName, sectionName)) {
        const requiredOption = { required: false };
        if (doLog())
          console.log(
            "[CrimeSubmission] setFieldRequiredSettingsOff   text field:",
            fieldName
          );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            validation: requiredOption,
          }),
        });
      }
    }

    for (let field in this.state.mappedSelectPropFields) {
      const fieldName = this.state.mappedSelectPropFields[field];
      if (this.getFieldRequiredFoundInSection(fieldName, sectionName)) {
        const required = false;
        const requiredOption = { required: required };
        if (doLog())
          console.log(
            "[CrimeSubmission] setFieldRequiredSettingsOff   select field:",
            fieldName
          );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            validation: requiredOption,
          }),
        });
      }
    }
  }

  render() {
    // if (doLog()) console.log("[render] loading:", this.props.loading);
    // if (doLog()) console.log("[render] result:", this.props.result);
    // if (doLog()) console.log("[render] error:", this.props.error);

    let errorMessage = null;
    if (this.props.error) {
      errorMessage = (
        <Grid item xs={12}>
          <p>{this.props.error.message}</p>
        </Grid>
      );
    }

    let requiredFieldErrMsg = null;
    if (!this.state.initialDownloadsComplete) {
      requiredFieldErrMsg = (
        <p className={classes.Alert}>{this.state.initialFieldErrMsg}</p>
      );
    } else if (this.checkRequiredField()) {
      requiredFieldErrMsg = (
        <p className={classes.Alert}>{this.state.requiredFieldErrMsg}</p>
      );
    }

    let welcomeText1 = this.getCustomText("Welcome_1");
    let welcomeText2 = this.getCustomText("Welcome_2");
    let welcomeText3 = this.getCustomText("Welcome_3");
    let welcomeRow2 = <p className={classes.ResultLabel}>{welcomeText2}</p>;

    if (this.isfbrPermitted()) {
      welcomeText2 = "Field Based Reporting";
      welcomeText3 = "";
      welcomeRow2 = <p className={classes.FormHeader}>{welcomeText2}</p>;
    }

    let formHeader = (
      <Grid container item spacing={gridSpacing}>
        <Grid item xs={12}>
          <p className={classes.FormHeader}>{welcomeText1}</p>
          {welcomeRow2}
          <p className={classes.Alert}>{welcomeText3}</p>
        </Grid>
        {errorMessage}
      </Grid>
    );

    let submitLabel = "Submit";
    let incidentNumberSection = null;
    if (hasValue(this.state.incidentNumber.value)) {
      const incidentNumber = this.state.incidentNumber.value;
      submitLabel = "Update";
      incidentNumberSection = (
        <Grid item xs={12}>
          <p>
            <span className={classes.BoldText}>
              Tracking number of the Incident being Modified:
            </span>
            &nbsp;{incidentNumber}
          </p>
        </Grid>
      );
    }

    let incidentDocumentationSection = null;
    if (
      this.state.selectedIncidentTypeData &&
      this.state.selectedIncidentTypeData !== null
    ) {
      incidentDocumentationSection = (
        <Grid
          container
          item
          spacing={gridSpacing}
          className={classes.FormFields}
        >
          <Grid item xs={12}>
            <hr />
          </Grid>
          <SectionHeading sectionTitle="Incident Overview" />
          {incidentNumberSection}
          <Grid item xs={12}>
            <p>
              <span className={classes.BoldText}>Selected Incident Type:</span>
              &nbsp;
              <span className={classes.EntryText}>
                {this.state.selectedIncidentTypeData.DESCRIPTION}
              </span>
            </p>
          </Grid>
          <Grid item xs={6} className={classes.InfoData}>
            <p className={classes.InfoHeading}>Definition of this type:</p>
            <p>{this.state.selectedIncidentTypeData.DEFINITION}</p>
          </Grid>
          <Grid item xs={6} className={classes.InfoData}>
            <p className={classes.InfoHeading}>Examples:</p>
            <p>{this.state.selectedIncidentTypeData.EXAMPLES}</p>
          </Grid>
          <Grid item xs={12}>
            <hr />
          </Grid>
        </Grid>
      );
    }

    let incidentSearchResults = null;
    let incidentListRows = [];
    if (
      hasValue(this.props.result !== null) &&
      hasValue(this.props.result.RESULT) &&
      hasValue(this.props.result.RESULT.CITIZENINCIDENT)
    ) {
      const array = this.props.result.RESULT.CITIZENINCIDENT;
      if (doLog())
        console.log("[CrimeSubmission] render incident array:", array);
      if (doLog())
        console.log(
          "[CrimeSubmission] render incident array length:",
          array.length
        );
      if (array !== null) {
        if (hasValue(array.length)) {
          for (let i = 0; i < array.length; i++) {
            const fields = array[i];
            let status = "Received";
            if (fields.STATUS === "acceptI") status = "Sent To RMS";
            else if (fields.STATUS === "reject") status = "NOT Sent To RMS";
            else if (fields.STATUS === "reqinfo") status = "More Info Needed";
            else if (fields.STATUS === "reqmade")
              status = "More Info Was Requested";
            else if (fields.STATUS === "response") {
              const date = getMMDDYYYY(fields.LASTUSERUPDATED);
              status = "Requested Info Received: " + date;
            }
            incidentListRows.push({
              id: i,
              incidentNumber: fields.INCIDENTNUMBER,
              typeCode: fields.ViaDataItems.CITIZENINCIDENTTYPE.DESCRIPTION,
              incidentDateTime: getMMDDYYYYTime(fields.INCIDENTDATETIME),
              status: status,
            });
          }
        } else {
          const fields = array;
          let status = "Received";
          if (fields.STATUS === "acceptI") status = "Sent to RMS";
          else if (fields.STATUS === "reject") status = "NOT Sent To RMS";
          else if (fields.STATUS === "reqinfo") status = "More Info Needed";
          else if (fields.STATUS === "reqmade")
            status = "More Info Was Requested";
          else if (fields.STATUS === "response") {
            const date = getMMDDYYYY(fields.LASTUSERUPDATED);
            status = "Requested Info Was Received: " + date;
          }

          incidentListRows.push({
            id: 0,
            incidentNumber: fields.INCIDENTNUMBER,
            typeCode: fields.ViaDataItems.CITIZENINCIDENTTYPE.DESCRIPTION,
            incidentDateTime: getMMDDYYYYTime(fields.INCIDENTDATETIME),
            status: status,
          });
        }
      }
    }

    const incidentListColumns = [
      {
        field: "incidentNumber",
        renderHeader: (params) => <strong>{"Tracking #"}</strong>,
        width: 120,
      },
      {
        field: "typeCode",
        renderHeader: (params) => <strong>{"Incident Type"}</strong>,
        width: 300,
      },
      {
        field: "incidentDateTime",
        renderHeader: (params) => <strong>{"Received Date/Time"}</strong>,
        width: 190,
      },
      {
        field: "status",
        renderHeader: (params) => <strong>{"Status"}</strong>,
        width: 300,
      },
    ];

    const incidentOptionSelect = (
      <Fragment>
        <Grid item xs={12}>
          <div style={{ height: headerHeight + rowHeight * 4 }}>
            <DataGrid
              rows={incidentListRows}
              columns={incidentListColumns}
              onRowClick={this.handleIncidentRowClick}
              getRowHeight={() => "auto"}
            />
          </div>
        </Grid>
      </Fragment>
    );

    let searchResults = null;
    let listRows = [];
    if (
      hasValue(this.props.result !== null) &&
      hasValue(this.props.result.RESULT) &&
      hasValue(this.props.result.RESULT.ADDRESS)
    ) {
      const array = this.props.result.RESULT.ADDRESS;
      if (doLog())
        console.log("[CrimeSubmission] render address array:", array);
      if (doLog())
        console.log(
          "[CrimeSubmission] render address array length:",
          array.length
        );
      if (array !== null) {
        if (hasValue(array.length)) {
          for (let i = 0; i < array.length; i++) {
            const fields = array[i];
            listRows.push({
              id: i,
              STREETNUMBER: fields.STREETNUMBER,
              STREETNAME: fields.STREETNAME,
              APARTMENT: fields.APARTMENT,
              CITY: fields.CITY,
              STATECODE: fields.STATECODE,
              POSTALCODE: fields.POSTALCODE,
              COMMONNAME: fields.COMMONNAME,
            });
          }
        } else if (hasValue(array.ADDRESSNUMBER)) {
          const fields = array;
          listRows.push({
            id: 1,
            STREETNUMBER: fields.STREETNUMBER,
            STREETNAME: fields.STREETNAME,
            APARTMENT: fields.APARTMENT,
            CITY: fields.CITY,
            STATECODE: fields.STATECODE,
            POSTALCODE: fields.POSTALCODE,
            COMMONNAME: fields.COMMONNAME,
          });
        }
      }
    }

    const listColumns = [
      {
        field: "STREETNUMBER",
        renderHeader: (params) => <strong>{"Number"}</strong>,
        width: 100,
      },
      {
        field: "STREETNAME",
        renderHeader: (params) => <strong>{"Street"}</strong>,
        width: 200,
      },
      {
        field: "APARTMENT",
        renderHeader: (params) => <strong>{"Unit"}</strong>,
        width: 90,
      },
      {
        field: "CITY",
        renderHeader: (params) => <strong>{"City"}</strong>,
        width: 180,
      },
      {
        field: "STATECODE",
        renderHeader: (params) => <strong>{"State"}</strong>,
        width: 30,
      },
      {
        field: "POSTALCODE",
        renderHeader: (params) => <strong>{"Zip"}</strong>,
        width: 75,
      },
      {
        field: "COMMONNAME",
        renderHeader: (params) => <strong>{"Common Name"}</strong>,
        width: 200,
      },
    ];

    const optionSelect = (
      <Fragment>
        <Grid item xs={12}>
          <div style={{ height: headerHeight + rowHeight * 4 }}>
            <DataGrid
              rows={listRows}
              columns={listColumns}
              onRowClick={this.handleSearchLocationRowClick}
              getRowHeight={() => "auto"}
            />
          </div>
        </Grid>
      </Fragment>
    );

    incidentSearchResults = <Fragment>{incidentOptionSelect}</Fragment>;
    searchResults = <Fragment>{optionSelect}</Fragment>;

    let searchOptionSection = null;
    let officerNameSection = null;
    let incidentSearchOptionSection = null;
    let incidentSearchSection = null;
    let searchSection = null;
    let fbrPermitted = this.isfbrPermitted();
    if (doLog()) console.log("CrimeSubmission permitted:", fbrPermitted);
    if (fbrPermitted) {
      searchOptionSection = (
        <Grid item xs={12}>
          {this.getFormField("timsSearch", false, true)}
        </Grid>
      );
      /*
      See Review.js filterSection
      Add incident number selection first (fill in the last incident for this user?  Stored where?)
      */

      incidentSearchOptionSection = (
        <Grid item xs={12}>
          {this.getFormField("priorIncidentSearch", false, true)}
        </Grid>
      );
      if (this.state.priorIncidentSearch.value === "Y") {
        incidentSearchSection = (
          <Fragment>
            <Grid item xs={12}>
              <hr />
            </Grid>
            <Grid item xs={3}>
              <p>From Date:</p>
            </Grid>
            <Grid item xs={3}>
              <p>To Date:</p>
            </Grid>
            {/* <Grid item xs={3}>
              <Checkbox
                checked={this.state.includeProcessed}
                onChange={this.handleFilterCheckBox()}
                color="default"
              />
              Include processed incidents
            </Grid> */}
            <Grid item xs={3} />
            <Grid item xs={3} />
            <Grid item xs={3}>
              {this.getFormField("paramStartDate", false, false)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("paramEndDate", false, false)}
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleSearchIncident.bind(this)}
              >
                Search
              </Button>
            </Grid>
            {incidentSearchResults}
            <Grid item xs={12}>
              <hr />
            </Grid>
          </Fragment>
        );
      }

      officerNameSection = (
        <Fragment>
          <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid item xs={12}>
            Officer: {this.state.personnelName}
          </Grid>
        </Fragment>
      );

      if (this.state.timsSearch.value === "Y") {
        searchSection = (
          <Fragment>
            {/* <Grid item xs={12}>
            (Use * for wildcards)
            </Grid> */}
            <Grid item xs={12}>
              {this.getFormField("incidentBusinessNameSearch", false, true)}
            </Grid>
            <Grid item xs={2}>
              {this.getFormField("incidentStreetNumberSearch", false, true)}
            </Grid>
            <Grid item xs={6}>
              {this.getFormField("incidentStreetNameSearch", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("incidentAptSearch", false, true)}
            </Grid>
            <Grid item xs={6}>
              {this.getFormField("incidentCitySearch", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("incidentStateSearch", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("incidentZipSearch", false, true)}
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleSearchLocationTIMS.bind(this)}
              >
                Search
              </Button>
            </Grid>
            {searchResults}
            <Grid item xs={12}>
              <hr />
            </Grid>
          </Fragment>
        );
      }
    }

    let incidentFields = null;
    if (
      hasValue(this.props.requiredFieldList) &&
      this.state.requiredFieldsComplete
    ) {
      incidentFields = (
        <Fragment>
          <Grid item xs={12}>
            <p className={classes.BoldText}>
              When did the incident occur? (Enter the beginning and end times)
            </p>
          </Grid>
          <Grid item xs={6}>
            {this.getFormField("incidentFromDate", false, true)}
          </Grid>
          <Grid item xs={6} />
          <Grid item xs={6}>
            {this.getFormField("incidentToDate", false, true)}
          </Grid>
          <Grid item xs={6} />
          <Grid item xs={12}>
            &nbsp;
          </Grid>
          <Grid item xs={12}>
            <p className={classes.BoldText}>What happened?</p>
          </Grid>
          <Grid item xs={12}>
            {this.getFormField("incidentDesc", false, true)}
          </Grid>
          <Grid item xs={12}>
            <p className={classes.BoldText}>Where did the incident occur?</p>
          </Grid>
          {searchOptionSection}
          {searchSection}
          <Grid item xs={12}>
            {this.getFormField("incidentBusinessName", true, true)}
          </Grid>
          <Grid item xs={2}>
            {this.getFormField("incidentStreetNumber", false, true)}
          </Grid>
          <Grid item xs={6}>
            {this.getFormField("incidentStreetName", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("incidentApt", false, true)}
          </Grid>
          <Grid item xs={6}>
            {this.getFormField("incidentCity", false, true)}
          </Grid>
          <Grid item xs={3}>
            {this.getFormField("incidentState", false, true)}
          </Grid>
          <Grid item xs={3}>
            {this.getFormField("incidentZip", false, true)}
          </Grid>
          <Grid item xs={12}>
            <hr />
          </Grid>
        </Fragment>
      );
    }

    let incidentOverview = null;
    if (
      this.state.selectedIncidentTypeData &&
      this.state.selectedIncidentTypeData !== null
    ) {
      incidentOverview = (
        <Card>
          <Grid container item className={classes.Card}>
            {incidentDocumentationSection}
            {incidentFields}
          </Grid>
        </Card>
      );
    }

    const incidentTypeText1 = this.getCustomText("IncidentType_1");
    let incidentSection = (
      <Fragment>
        <Card>
          <Grid container item className={classes.Card}>
            <p className={classes.Information}>
              First, we need general information about the incident.
            </p>
            {officerNameSection}
            {incidentSearchOptionSection}
            {incidentSearchSection}
            <Grid item xs={12}>
              <hr />
            </Grid>
            <Grid item xs={12}>
              What type of incident are you reporting?
            </Grid>
            <Grid item xs={12}>
              {incidentTypeText1}
            </Grid>
            <Grid item xs={12}>
              {this.getFormField("incidentTypeSearch", false, true)}
            </Grid>
            <Grid item xs={12}>
              {this.getFormField("incidentType", false, true)}
            </Grid>
          </Grid>
        </Card>
        {incidentOverview}
      </Fragment>
    );

    let towSection = null;
    if (hasValue(this.props.requiredFieldList)) {
      towSection = (
        <Card>
          <Grid container item className={classes.Card}>
            <SectionHeading sectionTitle="Towing Information" />
            <p className={classes.Information}>
              Next, please enter information about the towing organization used
              in the incident.
            </p>
            <Grid item xs={12}>
              <hr />
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("firstName", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("middleName", false, true)}
            </Grid>
            <Grid item xs={6}>
              {this.getFormField("lastName", false, true)}
            </Grid>
            <Grid item xs={6}>
              {this.getFormField("email", false, true)}
            </Grid>
            <Grid item xs={6} />
            <Grid item xs={8}>
              {this.getFormField("towCompanyName", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("workPhone", false, true)}
            </Grid>
            <Grid item xs={12}>
              <hr />
            </Grid>
            <Grid item xs={12} className={classes.Label}>
              Tow Company Address:
            </Grid>
            <Grid item xs={2}>
              {this.getFormField("towStreetNumber", false, true)}
            </Grid>
            <Grid item xs={6}>
              {this.getFormField("towStreetName", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("towApt", false, true)}
            </Grid>
            <Grid item xs={6}>
              {this.getFormField("towCity", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("towState", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("towZip", false, true)}
            </Grid>
          </Grid>
        </Card>
      );
    }

    let userOLNSection = null;
    if (
      hasValue(this.props.requiredFieldList) &&
      this.props.selectedIncidentTypeData &&
      this.props.selectedIncidentTypeData !== null &&
      this.props.selectedIncidentTypeData.REQUIREVEHICLEINFO === "Y"
    ) {
      userOLNSection = (
        <Fragment>
          <Grid item xs={3}>
            {this.getFormField("oln", false, true)}
          </Grid>
          <Grid item xs={3}>
            {this.getFormField("olnState", false, true)}
          </Grid>
          <Grid item xs={6} />
        </Fragment>
      );
    }

    let userSection = null;
    if (hasValue(this.props.requiredFieldList)) {
      if (!fbrPermitted) {
        userSection = (
          <Card>
            <Grid container item className={classes.Card}>
              <SectionHeading sectionTitle="Information About You" />
              <Grid item xs={12}>
                <p className={classes.Information}>
                  Next, we need information about you.
                </p>
                <p>
                  This will allow us to contact you if more details are needed
                  and to provide you with the status of the incident.
                </p>
              </Grid>
              <Grid item xs={12}>
                <hr />
              </Grid>
              <Grid item xs={4}>
                {this.getFormField("personInvolvement", false, true)}
              </Grid>
              <Grid item xs={8} />
              <Grid item xs={3}>
                {this.getFormField("firstName", false, true)}
              </Grid>
              <Grid item xs={3}>
                {this.getFormField("middleName", false, true)}
              </Grid>
              <Grid item xs={6}>
                {this.getFormField("lastName", false, true)}
              </Grid>
              <Grid item xs={6}>
                {this.getFormField("email", false, true)}
              </Grid>
              <Grid item xs={6} />
              <Grid item xs={4}>
                {this.getFormField("race", false, true)}
              </Grid>
              <Grid item xs={4}>
                {this.getFormField("ethnicity", false, true)}
              </Grid>
              <Grid item xs={4}>
                {this.getFormField("sex", false, true)}
              </Grid>
              <Grid item xs={4}>
                {this.getFormField("dob", false, true)}
              </Grid>
              {/* <Grid item xs={4}>
                {this.getFormField("eyeColor", false, true)}
              </Grid>
              <Grid item xs={4}>
                {this.getFormField("hairColor", false, true)}
              </Grid>
              <Grid item xs={4} /> */}
              <Grid item xs={4}>
                {this.getFormField("height", false, true)}
              </Grid>
              <Grid item xs={4}>
                {this.getFormField("weight", false, true)}
              </Grid>
              {/* <Grid item xs={4} /> */}
              <Grid item xs={4}>
                {this.getFormField("homePhone", false, true)}
              </Grid>
              <Grid item xs={4}>
                {this.getFormField("cellPhone", false, true)}
              </Grid>
              <Grid item xs={4}>
                {this.getFormField("workPhone", false, true)}
              </Grid>
              {userOLNSection}
              <Grid item xs={12}>
                <hr />
              </Grid>
              <Grid item xs={8} className={classes.Label}>
                Your Address:
                <Checkbox
                  checked={this.state.useSameAddress}
                  onChange={this.handleSameAddressCheckBox()}
                  color="default"
                />
                Same as Incident
              </Grid>
              <Grid item xs={12}>
                {this.getFormField("userBusinessName", true, true)}
              </Grid>
              <Grid item xs={2}>
                {this.getFormField("userStreetNumber", false, true)}
              </Grid>
              <Grid item xs={6}>
                {this.getFormField("userStreetName", false, true)}
              </Grid>
              <Grid item xs={4}>
                {this.getFormField("userApt", false, true)}
              </Grid>
              <Grid item xs={6}>
                {this.getFormField("userCity", false, true)}
              </Grid>
              <Grid item xs={3}>
                {this.getFormField("userState", false, true)}
              </Grid>
              <Grid item xs={3}>
                {this.getFormField("userZip", false, true)}
              </Grid>
            </Grid>
          </Card>
        );
      }
    }

    let optionalFormSection = null;
    if (
      hasValue(this.props.requiredFieldList) &&
      this.state.requiredFieldsComplete
    ) {
      optionalFormSection = (
        <Fragment>
          <Persons />
          <Vehicles />
          <Properties />
          <Attachments />
        </Fragment>
      );
    }

    let userDetailSection = null;
    if (this.props.requiredFieldList !== null) {
      userDetailSection = userSection;
      if (
        this.props.selectedIncidentTypeData &&
        this.props.selectedIncidentTypeData !== null &&
        this.props.selectedIncidentTypeData.REQUIRETOWINFO === "Y"
      ) {
        userDetailSection = towSection;
      }
    }

    let formFields = (
      <Grid container item spacing={gridSpacing}>
        {incidentSection}
        {userDetailSection}
        {optionalFormSection}
      </Grid>
    );

    if (
      this.state.initialDownloadsComplete === false ||
      this.props.incidentDetailsLoading
    ) {
      formFields = <Spinner />;
    }

    let newIncidentButtonSection = null;
    if (this.checkIncidentComplete()) {
      newIncidentButtonSection = (
        <Fragment>
          <Button
            variant="contained"
            //color="default"
            color="primary"
            size="small"
            onClick={this.handleNewIncidentButton.bind(this)}
          >
            Start a new Incident
          </Button>
          &nbsp;&nbsp;
        </Fragment>
      );
    }

    let resultDisplay = null;
    if (this.state.searching || this.state.reportRunning) {
      resultDisplay = <Spinner />;
    }
    if (
      !this.props.loading &&
      (this.props.reportResult != null || this.props.reportError != null)
    ) {
      // if (doLog()) console.log("[render] build formattedResult");
      let formattedResult = "";
      resultDisplay = null;
      if (this.props.reportError != null) {
        if (doLog()) console.log("reportError:" + this.props.reportError);
        formattedResult = "Error: " + this.props.reportError;
        resultDisplay = <pre>{formattedResult}</pre>;
        if (doLog()) console.log("[render] report result is an error");
      } else {
        if (typeof this.props.reportResult === "string") {
          formattedResult = this.props.reportResult;
          // if (doLog()) console.log("formattedResult string:" + formattedResult);
        } else {
          formattedResult = JSON.stringify(this.props.reportResult, null, 2);
          if (doLog()) console.log("formattedResult JSON:" + formattedResult);
        }
        if (formattedResult == null) {
          formattedResult = "";
          if (doLog()) console.log("formattedResult null:" + formattedResult);
        }
        const afterSubmitText1 = this.getCustomText("AfterSubmit_1");
        const afterSubmitText2 = this.getCustomText("AfterSubmit_2");
        const afterSubmitText3 = this.getCustomText("AfterSubmit_3");
        // if (doLog()) console.log('formattedResult:' + formattedResult);
        if (formattedResult.startsWith("JVBERi0x")) {
          //BASE64 version of %PDF
          const blobUrl = "data:application/pdf;base64," + formattedResult;
          resultDisplay = (
            <div>
              <p className={classes.ResultLabel}>{afterSubmitText1}</p>
              <p className={classes.ResultLabel}>{afterSubmitText2}</p>
              <p className={classes.ResultLabel}>{afterSubmitText3}</p>
              <object
                data={blobUrl}
                type="application/pdf"
                width="100%"
                height="1250px"
              >
                Report
              </object>
            </div>
          );
          if (doLog()) console.log("[render] result is a pdf");
        } else if (formattedResult.startsWith("File created:")) {
          const pdfFilePath = formattedResult.substring(22); // remove up to and including /webapps
          if (doLog()) console.log("[render] pdfFilePath:", pdfFilePath);
          const appPath = "";
          let filePath = "";
          const baseURL = this.props.baseURL;
          const pathname = ""; //this.props.pathname;
          if (doLog()) console.log("[render] pathname:", pathname);
          if (pathname.startsWith(appPath)) {
            filePath = baseURL + pathname + pdfFilePath;
          } else {
            filePath = baseURL + appPath + pathname + pdfFilePath;
          }
          if (doLog()) console.log("[render] filePath:", filePath);
          resultDisplay = (
            <Fragment>
              <p className={classes.ResultLabel}>{afterSubmitText1}</p>
              <p className={classes.ResultLabel}>{afterSubmitText2}</p>
              <p className={classes.ResultLabel}>{afterSubmitText3}</p>
              <Grid container item>
                <Grid item xs={12}>
                  <p className={classes.ResultLabel}>
                    <a href={filePath} download>
                      Download the PDF shown below. (You may need use the back
                      arrow to get back to this screen.)
                    </a>
                  </p>
                </Grid>
                <Grid item xs={12}>
                  <iframe
                    src={filePath}
                    title="Incident Report"
                    width="100%"
                    height="1250px"
                  ></iframe>
                </Grid>
              </Grid>
            </Fragment>
          );
        } else {
          resultDisplay = <pre>{formattedResult}</pre>;
          if (doLog()) console.log("[render] result is an formattedResult");
        }
      }
      if (doLog()) console.log("[render] resultDisplay:", resultDisplay);
    }

    return (
      <div className={classes.CrimeSubmission}>
        <Grid container item spacing={gridSpacing}>
          {formHeader}
          {formFields}
          <Grid item xs={12}>
            {requiredFieldErrMsg}
            <p>
              {newIncidentButtonSection}
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                disabled={
                  this.checkRequiredField() || this.checkIncidentComplete() || this.state.submitting
                }
                onClick={this.handleSendButton.bind(this)}
              >
                {submitLabel}
              </Button>
            </p>
          </Grid>
          <Grid item xs={12}>
            {resultDisplay}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("[CrimeSubmission] mapStateToProps state:", state);
  // if (doLog()) console.log('[CrimeSubmission mapStateToProps incidentTypeList:', state.trans.incidentTypeList);
  // if (doLog()) console.log("[CrimeSubmission] mapStateToProps personArray:", state.trans.personArray);
  return {
    loading: state.trans.loading,
    result: state.trans.result,
    error: state.trans.error,
    authError: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    modulePermissions: state.auth.modulePermissions,
    userId: state.auth.userId,
    multipleListLoading: state.trans.multipleListLoading,
    //
    baseURL: state.trans.baseURL,
    pathname: state.trans.pathname,
    //
    reportResult: state.trans.reportResult,
    reportError: state.trans.reportError,
    //
    upLoadNextIndex: state.trans.upLoadNextIndex,
    upLoadFileResult: state.trans.upLoadFileResult,
    upLoadFileError: state.trans.upLoadFileError,
    //
    agencyCode: state.trans.agencyCode,
    configuration: state.trans.configuration,
    incidentTypeList: state.trans.incidentTypeList,
    incidentTypeLoading: state.trans.incidentTypeLoading,
    incidentTypeDataList: state.trans.incidentTypeDataList,
    customTextList: state.trans.customTextList,
    customTextLoading: state.trans.customTextLoading,
    requiredFieldList: state.trans.requiredFieldList,
    requiredFieldLoading: state.trans.requiredFieldLoading,
    //
    incidentDetails: state.trans.incidentDetails,
    incidentDetailsLoading: state.trans.incidentDetailsLoading,
    //
    personInvolvementList: state.trans.personInvolvementList,
    raceList: state.trans.raceList,
    sexList: state.trans.sexList,
    ethnicityList: state.trans.ethnicityList,
    eyeColorList: state.trans.eyeColorList,
    hairColorList: state.trans.hairColorList,
    stateList: state.trans.stateList,
    //
    propertyTypeList: state.trans.propertyTypeList,
    propertyColorList: state.trans.vehicleColorList, //use vehicle colors to avoid issue when using the same codeGroupID
    //
    vehicleInvolvementList: state.trans.vehicleInvolvementList,
    vehicleBodyStyleList: state.trans.vehicleBodyStyleList,
    vehicleMakeList: state.trans.vehicleMakeList,
    vehicleColorList: state.trans.vehicleColorList,
    //
    selectedIncidentTypeData: state.trans.selectedIncidentTypeData,
    //
    attachmentArray: state.trans.attachmentArray,
    attachmentSelectFieldList: state.trans.attachmentSelectFieldList,
    attachmentTextFieldList: state.trans.attachmentTextFieldList,
    //
    personArray: state.trans.personArray,
    personSelectFieldList: state.trans.personSelectFieldList,
    personTextFieldList: state.trans.personTextFieldList,
    //
    propertyArray: state.trans.propertyArray,
    propertySelectFieldList: state.trans.propertySelectFieldList,
    propertyTextFieldList: state.trans.propertyTextFieldList,
    //
    vehicleArray: state.trans.vehicleArray,
    vehicleSelectFieldList: state.trans.vehicleSelectFieldList,
    vehicleTextFieldList: state.trans.vehicleTextFieldList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRunTransaction: (options, token) =>
      dispatch(actions.runTransaction(options, token)),
    onFetchIncidentTypeList: (ori, token) =>
      dispatch(actions.fetchIncidentTypeList(ori, token)),
    onFetchValidCodeLists: (
      ori,
      token,
      listName,
      codeGroup,
      allFields,
      includeInactive
    ) =>
      dispatch(
        actions.fetchValidCodeLists(
          ori,
          token,
          listName,
          codeGroup,
          allFields,
          includeInactive
        )
      ),
    onFetchMultipleValidCodeLists: (ori, token, options) =>
      dispatch(actions.fetchMultipleValidCodeLists(ori, token, options)),
    onSetIncidentTypeData: (selectedIncidentTypeData) =>
      dispatch(actions.setIncidentTypeData(selectedIncidentTypeData)),
    onFetchRequiredFieldList: (ori, token, type) =>
      dispatch(actions.fetchRequiredFieldList(ori, token, type)),
    onClearRequiredFieldList: () => dispatch(actions.clearRequiredFieldList()),
    onFetchCustomTextList: (agencyCode, token) =>
      dispatch(actions.fetchCustomTextList(agencyCode, token)),
    //
    onFetchIncidentDetails: (token, ori, id) =>
      dispatch(actions.fetchIncidentDetails(token, ori, id)),
    onSetSharedIncidentDetails: (sharedIncidentDetails) =>
      dispatch(actions.setSharedIncidentDetails(sharedIncidentDetails)),
    //
    onRunReport: (options, jsonResult, timeoutSecs, connectionName, token) =>
      dispatch(
        actions.runReport(
          options,
          jsonResult,
          timeoutSecs,
          connectionName,
          token
        )
      ),
    onClearReportResult: () => dispatch(actions.clearReportResult()),
    onSetAttachmentArray: (attachmentArray) =>
      dispatch(actions.setAttachmentArray(attachmentArray)),
    onSetPersonArray: (personArray) =>
      dispatch(actions.setPersonArray(personArray)),
    onSetPropertyArray: (propertyArray) =>
      dispatch(actions.setPropertyArray(propertyArray)),
    onSetVehicleArray: (vehicleArray) =>
      dispatch(actions.setVehicleArray(vehicleArray)),
    onUpLoadFile: (formData, token, index) =>
      dispatch(actions.upLoadFile(formData, token, index)),
    onClearUpLoadResult: () => dispatch(actions.clearUpLoadResult()),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearTransDesc: () => dispatch(actions.clearTransDesc()),
  };
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(CrimeSubmission)
);
